const enEmojis = {
    '😀': {
        keywords: ['smile', 'happy', 'face', 'grin'],
    },
    '😃': {
        keywords: ['happy', 'joy', 'haha', 'face', 'mouth', 'open', 'smile'],
    },
    '😄': {
        keywords: ['happy', 'joy', 'laugh', 'pleased', 'eye', 'face', 'mouth', 'open'],
    },
    '😁': {
        keywords: ['eye', 'face', 'smile'],
    },
    '😆': {
        keywords: ['happy', 'haha', 'satisfied', 'face', 'laugh', 'mouth', 'open', 'smile'],
    },
    '😅': {
        keywords: ['hot', 'cold', 'face', 'open', 'smile', 'sweat'],
    },
    '🤣': {
        keywords: ['lol', 'laughing', 'face', 'floor', 'laugh', 'rolling'],
    },
    '😂': {
        keywords: ['tears', 'face', 'laugh', 'tear'],
    },
    '🙂': {
        keywords: ['face', 'smile'],
    },
    '🙃': {
        keywords: ['face', 'upside-down'],
    },
    '😉': {
        keywords: ['flirt', 'face'],
    },
    '😊': {
        keywords: ['proud', 'eye', 'face', 'smile'],
    },
    '😇': {
        keywords: ['angel', 'face', 'fairy tale', 'fantasy', 'halo', 'smile'],
    },
    '🥰': {
        keywords: ['love'],
    },
    '😍': {
        keywords: ['love', 'crush', 'eye', 'face', 'heart', 'smile'],
    },
    '🤩': {
        keywords: ['eyes'],
    },
    '😘': {
        keywords: ['flirt', 'face', 'heart', 'kiss'],
    },
    '😗': {
        keywords: ['face', 'kiss'],
    },
    '☺️': {
        keywords: ['blush', 'pleased'],
    },
    '😚': {
        keywords: ['closed', 'eye', 'face', 'kiss'],
    },
    '😙': {
        keywords: ['eye', 'face', 'kiss', 'smile'],
    },
    '🥲': {
        keywords: [],
    },
    '😋': {
        keywords: ['tongue', 'lick', 'delicious', 'face', 'savouring', 'smile', 'um'],
    },
    '😛': {
        keywords: ['face', 'tongue'],
    },
    '😜': {
        keywords: ['prank', 'silly', 'eye', 'face', 'joke', 'tongue', 'wink'],
    },
    '🤪': {
        keywords: ['goofy', 'wacky'],
    },
    '😝': {
        keywords: ['prank', 'eye', 'face', 'horrible', 'taste', 'tongue'],
    },
    '🤑': {
        keywords: ['rich', 'face', 'money', 'mouth'],
    },
    '🤗': {
        keywords: ['face', 'hug', 'hugging'],
    },
    '🤭': {
        keywords: ['quiet', 'whoops'],
    },
    '🤫': {
        keywords: ['silence', 'quiet'],
    },
    '🤔': {
        keywords: ['face'],
    },
    '🤐': {
        keywords: ['silence', 'hush', 'face', 'mouth', 'zipper'],
    },
    '🤨': {
        keywords: ['suspicious'],
    },
    '😐': {
        keywords: ['meh', 'deadpan', 'face', 'neutral'],
    },
    '😑': {
        keywords: ['face', 'inexpressive', 'unexpressive'],
    },
    '😶': {
        keywords: ['mute', 'silence', 'face', 'mouth', 'quiet', 'silent'],
    },
    '😶‍🌫️': {
        keywords: [],
    },
    '😏': {
        keywords: ['smug', 'face'],
    },
    '😒': {
        keywords: ['meh', 'face', 'unhappy'],
    },
    '🙄': {
        keywords: ['eyes', 'face', 'rolling'],
    },
    '😬': {
        keywords: ['face', 'grimace'],
    },
    '😮‍💨': {
        keywords: [],
    },
    '🤥': {
        keywords: ['liar', 'face', 'lie', 'pinocchio'],
    },
    '😌': {
        keywords: ['whew', 'face'],
    },
    '😔': {
        keywords: ['dejected', 'face'],
    },
    '😪': {
        keywords: ['tired', 'face', 'sleep'],
    },
    '🤤': {
        keywords: ['drooling', 'face'],
    },
    '😴': {
        keywords: ['zzz', 'face', 'sleep'],
    },
    '😷': {
        keywords: ['sick', 'ill', 'cold', 'doctor', 'face', 'medicine'],
    },
    '🤒': {
        keywords: ['sick', 'face', 'ill', 'thermometer'],
    },
    '🤕': {
        keywords: ['hurt', 'bandage', 'face', 'injury'],
    },
    '🤢': {
        keywords: ['sick', 'barf', 'disgusted', 'face', 'nauseated', 'vomit'],
    },
    '🤮': {
        keywords: ['barf', 'sick'],
    },
    '🤧': {
        keywords: ['achoo', 'sick', 'face', 'gesundheit', 'sneeze'],
    },
    '🥵': {
        keywords: ['heat', 'sweating'],
    },
    '🥶': {
        keywords: ['freezing', 'ice'],
    },
    '🥴': {
        keywords: ['groggy'],
    },
    '😵': {
        keywords: ['dizzy', 'face'],
    },
    '😵‍💫': {
        keywords: [],
    },
    '🤯': {
        keywords: ['mind', 'blown'],
    },
    '🤠': {
        keywords: ['cowboy', 'cowgirl', 'face', 'hat'],
    },
    '🥳': {
        keywords: ['celebration', 'birthday'],
    },
    '🥸': {
        keywords: [],
    },
    '😎': {
        keywords: ['cool', 'bright', 'eye', 'eyewear', 'face', 'glasses', 'smile', 'sun', 'weather'],
    },
    '🤓': {
        keywords: ['geek', 'glasses', 'face', 'nerd'],
    },
    '🧐': {
        keywords: [],
    },
    '😕': {
        keywords: ['face'],
    },
    '😟': {
        keywords: ['nervous', 'face'],
    },
    '🙁': {
        keywords: ['face', 'frown'],
    },
    '☹️': {
        keywords: [],
    },
    '😮': {
        keywords: ['surprise', 'impressed', 'wow', 'face', 'mouth', 'open', 'sympathy'],
    },
    '😯': {
        keywords: ['silence', 'speechless', 'face', 'stunned', 'surprised'],
    },
    '😲': {
        keywords: ['amazed', 'gasp', 'face', 'shocked', 'totally'],
    },
    '😳': {
        keywords: ['dazed', 'face'],
    },
    '🥺': {
        keywords: ['puppy', 'eyes'],
    },
    '😦': {
        keywords: ['face', 'frown', 'mouth', 'open'],
    },
    '😧': {
        keywords: ['stunned', 'face'],
    },
    '😨': {
        keywords: ['scared', 'shocked', 'oops', 'face', 'fear'],
    },
    '😰': {
        keywords: ['nervous', 'blue', 'cold', 'face', 'mouth', 'open', 'rushed', 'sweat'],
    },
    '😥': {
        keywords: ['phew', 'sweat', 'nervous', 'disappointed', 'face', 'relieved', 'whew'],
    },
    '😢': {
        keywords: ['sad', 'tear', 'face'],
    },
    '😭': {
        keywords: ['sad', 'cry', 'bawling', 'face', 'tear'],
    },
    '😱': {
        keywords: ['horror', 'shocked', 'face', 'fear', 'fearful', 'munch', 'scared'],
    },
    '😖': {
        keywords: ['face'],
    },
    '😣': {
        keywords: ['struggling', 'face'],
    },
    '😞': {
        keywords: ['sad', 'face'],
    },
    '😓': {
        keywords: ['cold', 'face'],
    },
    '😩': {
        keywords: ['tired', 'face'],
    },
    '😫': {
        keywords: ['upset', 'whine', 'face', 'tired'],
    },
    '🥱': {
        keywords: [],
    },
    '😤': {
        keywords: ['smug', 'face', 'won'],
    },
    '😡': {
        keywords: ['angry', 'pout', 'face', 'mad', 'pouting', 'red'],
    },
    '😠': {
        keywords: ['mad', 'annoyed', 'face'],
    },
    '🤬': {
        keywords: ['foul'],
    },
    '😈': {
        keywords: ['devil', 'evil', 'horns', 'face', 'fairy tale', 'fantasy', 'smile'],
    },
    '👿': {
        keywords: ['angry', 'devil', 'evil', 'horns', 'demon', 'face', 'fairy tale', 'fantasy'],
    },
    '💀': {
        keywords: ['dead', 'danger', 'poison', 'body', 'death', 'face', 'fairy tale', 'monster'],
    },
    '☠️': {
        keywords: ['danger', 'pirate', 'body', 'crossbones', 'death', 'face', 'monster', 'skull'],
    },
    '💩': {
        keywords: ['crap', 'poop', 'shit', 'comic', 'dung', 'face', 'monster', 'poo'],
    },
    '🤡': {
        keywords: ['clown', 'face'],
    },
    '👹': {
        keywords: ['monster', 'creature', 'face', 'fairy tale', 'fantasy', 'japanese', 'ogre'],
    },
    '👺': {
        keywords: ['creature', 'face', 'fairy tale', 'fantasy', 'goblin', 'japanese', 'monster'],
    },
    '👻': {
        keywords: ['halloween', 'creature', 'face', 'fairy tale', 'fantasy', 'monster'],
    },
    '👽': {
        keywords: ['ufo', 'creature', 'extraterrestrial', 'face', 'fairy tale', 'fantasy', 'monster', 'space'],
    },
    '👾': {
        keywords: ['game', 'retro', 'alien', 'creature', 'extraterrestrial', 'face', 'fairy tale', 'fantasy', 'monster', 'space', 'ufo'],
    },
    '🤖': {
        keywords: ['face', 'monster'],
    },
    '😺': {
        keywords: ['cat', 'face', 'mouth', 'open', 'smile'],
    },
    '😸': {
        keywords: ['cat', 'eye', 'face', 'grin', 'smile'],
    },
    '😹': {
        keywords: ['cat', 'face', 'joy', 'tear'],
    },
    '😻': {
        keywords: ['cat', 'eye', 'face', 'heart', 'love', 'smile'],
    },
    '😼': {
        keywords: ['cat', 'face', 'ironic', 'smile', 'wry'],
    },
    '😽': {
        keywords: ['cat', 'eye', 'face', 'kiss'],
    },
    '🙀': {
        keywords: ['horror', 'cat', 'face', 'oh', 'surprised', 'weary'],
    },
    '😿': {
        keywords: ['sad', 'tear', 'cat', 'cry', 'face'],
    },
    '😾': {
        keywords: ['cat', 'face', 'pouting'],
    },
    '🙈': {
        keywords: ['monkey', 'blind', 'ignore', 'evil', 'face', 'forbidden', 'gesture', 'no', 'not', 'prohibited', 'see'],
    },
    '🙉': {
        keywords: ['monkey', 'deaf', 'evil', 'face', 'forbidden', 'gesture', 'hear', 'no', 'not', 'prohibited'],
    },
    '🙊': {
        keywords: ['monkey', 'mute', 'hush', 'evil', 'face', 'forbidden', 'gesture', 'no', 'not', 'prohibited', 'speak'],
    },
    '💋': {
        keywords: ['lipstick', 'heart', 'lips', 'mark', 'romance'],
    },
    '💌': {
        keywords: ['email', 'envelope', 'heart', 'letter', 'love', 'mail', 'romance'],
    },
    '💘': {
        keywords: ['love', 'heart', 'arrow', 'romance'],
    },
    '💝': {
        keywords: ['chocolates', 'heart', 'ribbon', 'valentine'],
    },
    '💖': {
        keywords: ['excited', 'heart', 'sparkle'],
    },
    '💗': {
        keywords: ['excited', 'growing', 'heart', 'nervous'],
    },
    '💓': {
        keywords: ['beating', 'heart', 'pulsating'],
    },
    '💞': {
        keywords: ['heart', 'revolving'],
    },
    '💕': {
        keywords: ['heart', 'love'],
    },
    '💟': {
        keywords: ['heart'],
    },
    '❣️': {
        keywords: ['exclamation', 'heart', 'mark', 'punctuation'],
    },
    '💔': {
        keywords: ['break', 'broken', 'heart'],
    },
    '❤️‍🔥': {
        keywords: [],
    },
    '❤️‍🩹': {
        keywords: [],
    },
    '❤️': {
        keywords: ['love'],
    },
    '🧡': {
        keywords: [],
    },
    '💛': {
        keywords: ['heart', 'yellow'],
    },
    '💚': {
        keywords: ['green', 'heart'],
    },
    '💙': {
        keywords: ['blue', 'heart'],
    },
    '💜': {
        keywords: ['heart', 'purple'],
    },
    '🤎': {
        keywords: [],
    },
    '🖤': {
        keywords: ['black', 'evil', 'heart', 'wicked'],
    },
    '🤍': {
        keywords: [],
    },
    '💯': {
        keywords: ['score', 'perfect', 'full', 'hundred'],
    },
    '💢': {
        keywords: ['angry', 'comic', 'mad'],
    },
    '💥': {
        keywords: ['explode', 'collision', 'comic'],
    },
    '💫': {
        keywords: ['star', 'comic'],
    },
    '💦': {
        keywords: ['water', 'workout', 'comic', 'splashing', 'sweat'],
    },
    '💨': {
        keywords: ['wind', 'blow', 'fast', 'comic', 'running'],
    },
    '🕳️': {
        keywords: [],
    },
    '💣': {
        keywords: ['boom', 'comic'],
    },
    '💬': {
        keywords: ['comment', 'balloon', 'bubble', 'comic', 'dialog', 'speech'],
    },
    '👁️‍🗨️': {
        keywords: [],
    },
    '🗨️': {
        keywords: [],
    },
    '🗯️': {
        keywords: [],
    },
    '💭': {
        keywords: ['thinking', 'balloon', 'bubble', 'comic', 'thought'],
    },
    '💤': {
        keywords: ['sleeping', 'comic', 'sleep'],
    },
    '👋': {
        keywords: ['goodbye', 'body', 'hand', 'waving'],
    },
    '🤚': {
        keywords: ['backhand', 'raised'],
    },
    '🖐️': {
        keywords: [],
    },
    '✋': {
        keywords: ['highfive', 'stop', 'raised_hand', 'body'],
    },
    '🖖': {
        keywords: ['prosper', 'spock', 'body', 'finger', 'hand', 'vulcan'],
    },
    '👌': {
        keywords: ['body', 'hand', 'ok'],
    },
    '🤌': {
        keywords: [],
    },
    '🤏': {
        keywords: [],
    },
    '✌️': {
        keywords: ['victory', 'peace'],
    },
    '🤞': {
        keywords: ['luck', 'hopeful', 'cross', 'finger', 'hand'],
    },
    '🤟': {
        keywords: [],
    },
    '🤘': {
        keywords: ['body', 'finger', 'hand', 'horns', 'rock-on'],
    },
    '🤙': {
        keywords: ['call', 'hand', 'shaka'],
    },
    '👈': {
        keywords: ['backhand', 'body', 'finger', 'hand', 'index', 'point'],
    },
    '👉': {
        keywords: ['backhand', 'body', 'finger', 'hand', 'index', 'point'],
    },
    '👆': {
        keywords: ['backhand', 'body', 'finger', 'hand', 'index', 'point', 'up'],
    },
    '🖕': {
        keywords: ['fu', 'body', 'finger', 'hand', 'middle finger'],
    },
    '👇': {
        keywords: ['backhand', 'body', 'down', 'finger', 'hand', 'index', 'point'],
    },
    '☝️': {
        keywords: [],
    },
    '👍': {
        keywords: ['approve', 'ok', 'thumbsup', 'body', 'hand', 'thumb', 'thumbs up', 'up'],
    },
    '👎': {
        keywords: ['disapprove', 'bury', 'thumbsdown', 'body', 'down', 'hand', 'thumb', 'thumbs down'],
    },
    '✊': {
        keywords: ['power', 'fist', 'body', 'clenched', 'hand', 'punch'],
    },
    '👊': {
        keywords: ['attack', 'facepunch', 'punch', 'body', 'clenched', 'fist', 'hand'],
    },
    '🤛': {
        keywords: ['fist', 'leftwards'],
    },
    '🤜': {
        keywords: ['fist', 'rightwards'],
    },
    '👏': {
        keywords: ['praise', 'applause', 'body', 'hand'],
    },
    '🙌': {
        keywords: ['hooray', 'body', 'celebration', 'gesture', 'hand', 'raised'],
    },
    '👐': {
        keywords: ['body', 'hand', 'open'],
    },
    '🤲': {
        keywords: [],
    },
    '🤝': {
        keywords: ['deal', 'agreement', 'hand', 'meeting', 'shake'],
    },
    '🙏': {
        keywords: ['please', 'hope', 'wish', 'ask', 'body', 'bow', 'folded', 'gesture', 'hand', 'thanks'],
    },
    '✍️': {
        keywords: [],
    },
    '💅': {
        keywords: ['beauty', 'manicure', 'body', 'care', 'cosmetics', 'nail', 'polish'],
    },
    '🤳': {
        keywords: ['camera', 'phone'],
    },
    '💪': {
        keywords: ['flex', 'bicep', 'strong', 'workout', 'biceps', 'body', 'comic'],
    },
    '🦾': {
        keywords: [],
    },
    '🦿': {
        keywords: [],
    },
    '🦵': {
        keywords: [],
    },
    '🦶': {
        keywords: [],
    },
    '👂': {
        keywords: ['hear', 'sound', 'listen', 'body'],
    },
    '🦻': {
        keywords: [],
    },
    '👃': {
        keywords: ['smell', 'body'],
    },
    '🧠': {
        keywords: [],
    },
    '🫀': {
        keywords: [],
    },
    '🫁': {
        keywords: [],
    },
    '🦷': {
        keywords: [],
    },
    '🦴': {
        keywords: [],
    },
    '👀': {
        keywords: ['look', 'see', 'watch', 'body', 'eye', 'face'],
    },
    '👁️': {
        keywords: [],
    },
    '👅': {
        keywords: ['taste', 'body'],
    },
    '👄': {
        keywords: ['kiss', 'body', 'mouth'],
    },
    '👶': {
        keywords: ['child', 'newborn'],
    },
    '🧒': {
        keywords: [],
    },
    '👦': {
        keywords: ['child'],
    },
    '👧': {
        keywords: ['child', 'maiden', 'virgin', 'virgo', 'zodiac'],
    },
    '🧑': {
        keywords: [],
    },
    '👱': {
        keywords: ['blond'],
    },
    '👨': {
        keywords: ['mustache', 'father', 'dad'],
    },
    '🧔': {
        keywords: [],
    },
    '🧔‍♂️': {
        keywords: [],
    },
    '🧔‍♀️': {
        keywords: [],
    },
    '👨‍🦰': {
        keywords: [],
    },
    '👨‍🦱': {
        keywords: [],
    },
    '👨‍🦳': {
        keywords: [],
    },
    '👨‍🦲': {
        keywords: [],
    },
    '👩': {
        keywords: ['girls'],
    },
    '👩‍🦰': {
        keywords: [],
    },
    '🧑‍🦰': {
        keywords: [],
    },
    '👩‍🦱': {
        keywords: [],
    },
    '🧑‍🦱': {
        keywords: [],
    },
    '👩‍🦳': {
        keywords: [],
    },
    '🧑‍🦳': {
        keywords: [],
    },
    '👩‍🦲': {
        keywords: [],
    },
    '🧑‍🦲': {
        keywords: [],
    },
    '👱‍♀️': {
        keywords: ['blonde_woman'],
    },
    '👱‍♂️': {
        keywords: [],
    },
    '🧓': {
        keywords: [],
    },
    '👴': {
        keywords: ['man', 'old'],
    },
    '👵': {
        keywords: ['old', 'woman'],
    },
    '🙍': {
        keywords: ['frown', 'gesture'],
    },
    '🙍‍♂️': {
        keywords: [],
    },
    '🙍‍♀️': {
        keywords: [],
    },
    '🙎': {
        keywords: ['gesture', 'pouting'],
    },
    '🙎‍♂️': {
        keywords: [],
    },
    '🙎‍♀️': {
        keywords: [],
    },
    '🙅': {
        keywords: ['stop', 'halt', 'denied', 'forbidden', 'gesture', 'hand', 'no', 'not', 'prohibited'],
    },
    '🙅‍♂️': {
        keywords: ['stop', 'halt', 'denied', 'ng_man'],
    },
    '🙅‍♀️': {
        keywords: ['stop', 'halt', 'denied', 'ng_woman'],
    },
    '🙆': {
        keywords: ['gesture', 'hand', 'ok'],
    },
    '🙆‍♂️': {
        keywords: [],
    },
    '🙆‍♀️': {
        keywords: [],
    },
    '💁': {
        keywords: ['information_desk_person', 'hand', 'help', 'information', 'sassy'],
    },
    '💁‍♂️': {
        keywords: ['information', 'sassy_man'],
    },
    '💁‍♀️': {
        keywords: ['information', 'sassy_woman'],
    },
    '🙋': {
        keywords: ['gesture', 'hand', 'happy', 'raised'],
    },
    '🙋‍♂️': {
        keywords: [],
    },
    '🙋‍♀️': {
        keywords: [],
    },
    '🧏': {
        keywords: [],
    },
    '🧏‍♂️': {
        keywords: [],
    },
    '🧏‍♀️': {
        keywords: [],
    },
    '🙇': {
        keywords: ['respect', 'thanks', 'apology', 'gesture', 'sorry'],
    },
    '🙇‍♂️': {
        keywords: ['respect', 'thanks'],
    },
    '🙇‍♀️': {
        keywords: ['respect', 'thanks'],
    },
    '🤦': {
        keywords: ['disbelief', 'exasperation', 'face', 'palm'],
    },
    '🤦‍♂️': {
        keywords: [],
    },
    '🤦‍♀️': {
        keywords: [],
    },
    '🤷': {
        keywords: ['doubt', 'ignorance', 'indifference'],
    },
    '🤷‍♂️': {
        keywords: [],
    },
    '🤷‍♀️': {
        keywords: [],
    },
    '🧑‍⚕️': {
        keywords: [],
    },
    '👨‍⚕️': {
        keywords: ['doctor', 'nurse'],
    },
    '👩‍⚕️': {
        keywords: ['doctor', 'nurse'],
    },
    '🧑‍🎓': {
        keywords: [],
    },
    '👨‍🎓': {
        keywords: ['graduation'],
    },
    '👩‍🎓': {
        keywords: ['graduation'],
    },
    '🧑‍🏫': {
        keywords: [],
    },
    '👨‍🏫': {
        keywords: ['school', 'professor'],
    },
    '👩‍🏫': {
        keywords: ['school', 'professor'],
    },
    '🧑‍⚖️': {
        keywords: [],
    },
    '👨‍⚖️': {
        keywords: ['justice'],
    },
    '👩‍⚖️': {
        keywords: ['justice'],
    },
    '🧑‍🌾': {
        keywords: [],
    },
    '👨‍🌾': {
        keywords: [],
    },
    '👩‍🌾': {
        keywords: [],
    },
    '🧑‍🍳': {
        keywords: [],
    },
    '👨‍🍳': {
        keywords: ['chef'],
    },
    '👩‍🍳': {
        keywords: ['chef'],
    },
    '🧑‍🔧': {
        keywords: [],
    },
    '👨‍🔧': {
        keywords: [],
    },
    '👩‍🔧': {
        keywords: [],
    },
    '🧑‍🏭': {
        keywords: [],
    },
    '👨‍🏭': {
        keywords: [],
    },
    '👩‍🏭': {
        keywords: [],
    },
    '🧑‍💼': {
        keywords: [],
    },
    '👨‍💼': {
        keywords: ['business'],
    },
    '👩‍💼': {
        keywords: ['business'],
    },
    '🧑‍🔬': {
        keywords: [],
    },
    '👨‍🔬': {
        keywords: ['research'],
    },
    '👩‍🔬': {
        keywords: ['research'],
    },
    '🧑‍💻': {
        keywords: [],
    },
    '👨‍💻': {
        keywords: ['coder'],
    },
    '👩‍💻': {
        keywords: ['coder'],
    },
    '🧑‍🎤': {
        keywords: [],
    },
    '👨‍🎤': {
        keywords: ['rockstar'],
    },
    '👩‍🎤': {
        keywords: ['rockstar'],
    },
    '🧑‍🎨': {
        keywords: [],
    },
    '👨‍🎨': {
        keywords: ['painter'],
    },
    '👩‍🎨': {
        keywords: ['painter'],
    },
    '🧑‍✈️': {
        keywords: [],
    },
    '👨‍✈️': {
        keywords: [],
    },
    '👩‍✈️': {
        keywords: [],
    },
    '🧑‍🚀': {
        keywords: [],
    },
    '👨‍🚀': {
        keywords: ['space'],
    },
    '👩‍🚀': {
        keywords: ['space'],
    },
    '🧑‍🚒': {
        keywords: [],
    },
    '👨‍🚒': {
        keywords: [],
    },
    '👩‍🚒': {
        keywords: [],
    },
    '👮': {
        keywords: ['law', 'cop', 'officer', 'police'],
    },
    '👮‍♂️': {
        keywords: ['law', 'cop'],
    },
    '👮‍♀️': {
        keywords: ['law', 'cop'],
    },
    '🕵️': {
        keywords: ['sleuth'],
    },
    '🕵️‍♂️': {
        keywords: ['sleuth'],
    },
    '🕵️‍♀️': {
        keywords: ['sleuth'],
    },
    '💂': {
        keywords: ['guardsman'],
    },
    '💂‍♂️': {
        keywords: [],
    },
    '💂‍♀️': {
        keywords: [],
    },
    '🥷': {
        keywords: [],
    },
    '👷': {
        keywords: ['helmet', 'construction', 'hat', 'worker'],
    },
    '👷‍♂️': {
        keywords: ['helmet'],
    },
    '👷‍♀️': {
        keywords: ['helmet'],
    },
    '🤴': {
        keywords: ['crown', 'royal'],
    },
    '👸': {
        keywords: ['crown', 'royal', 'fairy tale', 'fantasy'],
    },
    '👳': {
        keywords: ['man', 'turban'],
    },
    '👳‍♂️': {
        keywords: [],
    },
    '👳‍♀️': {
        keywords: [],
    },
    '👲': {
        keywords: ['gua pi mao', 'hat', 'man'],
    },
    '🧕': {
        keywords: ['hijab'],
    },
    '🤵': {
        keywords: ['groom', 'marriage', 'wedding', 'man', 'tuxedo'],
    },
    '🤵‍♂️': {
        keywords: [],
    },
    '🤵‍♀️': {
        keywords: [],
    },
    '👰': {
        keywords: ['marriage', 'wedding', 'bride', 'veil'],
    },
    '👰‍♂️': {
        keywords: [],
    },
    '👰‍♀️': {
        keywords: ['bride_with_veil'],
    },
    '🤰': {
        keywords: ['pregnant', 'woman'],
    },
    '🤱': {
        keywords: ['nursing'],
    },
    '👩‍🍼': {
        keywords: [],
    },
    '👨‍🍼': {
        keywords: [],
    },
    '🧑‍🍼': {
        keywords: [],
    },
    '👼': {
        keywords: ['baby', 'face', 'fairy tale', 'fantasy'],
    },
    '🎅': {
        keywords: ['christmas', 'activity', 'celebration', 'fairy tale', 'fantasy', 'father'],
    },
    '🤶': {
        keywords: ['santa', 'christmas', 'mother', 'mrs. claus'],
    },
    '🧑‍🎄': {
        keywords: [],
    },
    '🦸': {
        keywords: [],
    },
    '🦸‍♂️': {
        keywords: [],
    },
    '🦸‍♀️': {
        keywords: [],
    },
    '🦹': {
        keywords: [],
    },
    '🦹‍♂️': {
        keywords: [],
    },
    '🦹‍♀️': {
        keywords: [],
    },
    '🧙': {
        keywords: ['wizard'],
    },
    '🧙‍♂️': {
        keywords: ['wizard'],
    },
    '🧙‍♀️': {
        keywords: ['wizard'],
    },
    '🧚': {
        keywords: [],
    },
    '🧚‍♂️': {
        keywords: [],
    },
    '🧚‍♀️': {
        keywords: [],
    },
    '🧛': {
        keywords: [],
    },
    '🧛‍♂️': {
        keywords: [],
    },
    '🧛‍♀️': {
        keywords: [],
    },
    '🧜': {
        keywords: [],
    },
    '🧜‍♂️': {
        keywords: [],
    },
    '🧜‍♀️': {
        keywords: [],
    },
    '🧝': {
        keywords: [],
    },
    '🧝‍♂️': {
        keywords: [],
    },
    '🧝‍♀️': {
        keywords: [],
    },
    '🧞': {
        keywords: [],
    },
    '🧞‍♂️': {
        keywords: [],
    },
    '🧞‍♀️': {
        keywords: [],
    },
    '🧟': {
        keywords: [],
    },
    '🧟‍♂️': {
        keywords: [],
    },
    '🧟‍♀️': {
        keywords: [],
    },
    '💆': {
        keywords: ['spa', 'salon'],
    },
    '💆‍♂️': {
        keywords: ['spa'],
    },
    '💆‍♀️': {
        keywords: ['spa'],
    },
    '💇': {
        keywords: ['beauty', 'barber', 'parlor'],
    },
    '💇‍♂️': {
        keywords: [],
    },
    '💇‍♀️': {
        keywords: [],
    },
    '🚶': {
        keywords: ['hike', 'pedestrian', 'walk'],
    },
    '🚶‍♂️': {
        keywords: [],
    },
    '🚶‍♀️': {
        keywords: [],
    },
    '🧍': {
        keywords: [],
    },
    '🧍‍♂️': {
        keywords: [],
    },
    '🧍‍♀️': {
        keywords: [],
    },
    '🧎': {
        keywords: [],
    },
    '🧎‍♂️': {
        keywords: [],
    },
    '🧎‍♀️': {
        keywords: [],
    },
    '🧑‍🦯': {
        keywords: [],
    },
    '👨‍🦯': {
        keywords: [],
    },
    '👩‍🦯': {
        keywords: [],
    },
    '🧑‍🦼': {
        keywords: [],
    },
    '👨‍🦼': {
        keywords: [],
    },
    '👩‍🦼': {
        keywords: [],
    },
    '🧑‍🦽': {
        keywords: [],
    },
    '👨‍🦽': {
        keywords: [],
    },
    '👩‍🦽': {
        keywords: [],
    },
    '🏃': {
        keywords: ['exercise', 'workout', 'marathon', 'running'],
    },
    '🏃‍♂️': {
        keywords: ['exercise', 'workout', 'marathon'],
    },
    '🏃‍♀️': {
        keywords: ['exercise', 'workout', 'marathon'],
    },
    '💃': {
        keywords: ['dress', 'dancer'],
    },
    '🕺': {
        keywords: ['dancer', 'dance', 'man'],
    },
    '🕴️': {
        keywords: [],
    },
    '👯': {
        keywords: ['bunny', 'dancer', 'ear', 'girl', 'woman'],
    },
    '👯‍♂️': {
        keywords: ['bunny'],
    },
    '👯‍♀️': {
        keywords: ['bunny'],
    },
    '🧖': {
        keywords: ['steamy'],
    },
    '🧖‍♂️': {
        keywords: ['steamy'],
    },
    '🧖‍♀️': {
        keywords: ['steamy'],
    },
    '🧗': {
        keywords: ['bouldering'],
    },
    '🧗‍♂️': {
        keywords: ['bouldering'],
    },
    '🧗‍♀️': {
        keywords: ['bouldering'],
    },
    '🤺': {
        keywords: ['fencer', 'fencing', 'sword'],
    },
    '🏇': {
        keywords: ['horse', 'jockey', 'racehorse', 'racing'],
    },
    '⛷️': {
        keywords: [],
    },
    '🏂': {
        keywords: ['ski', 'snow', 'snowboard'],
    },
    '🏌️': {
        keywords: [],
    },
    '🏌️‍♂️': {
        keywords: [],
    },
    '🏌️‍♀️': {
        keywords: [],
    },
    '🏄': {
        keywords: ['surfing'],
    },
    '🏄‍♂️': {
        keywords: [],
    },
    '🏄‍♀️': {
        keywords: [],
    },
    '🚣': {
        keywords: ['boat', 'vehicle'],
    },
    '🚣‍♂️': {
        keywords: [],
    },
    '🚣‍♀️': {
        keywords: [],
    },
    '🏊': {
        keywords: ['swim'],
    },
    '🏊‍♂️': {
        keywords: [],
    },
    '🏊‍♀️': {
        keywords: [],
    },
    '⛹️': {
        keywords: ['basketball'],
    },
    '⛹️‍♂️': {
        keywords: ['basketball_man'],
    },
    '⛹️‍♀️': {
        keywords: ['basketball_woman'],
    },
    '🏋️': {
        keywords: ['gym', 'workout'],
    },
    '🏋️‍♂️': {
        keywords: ['gym', 'workout'],
    },
    '🏋️‍♀️': {
        keywords: ['gym', 'workout'],
    },
    '🚴': {
        keywords: ['bicycle', 'bike', 'cyclist'],
    },
    '🚴‍♂️': {
        keywords: [],
    },
    '🚴‍♀️': {
        keywords: [],
    },
    '🚵': {
        keywords: ['bicycle', 'bicyclist', 'bike', 'cyclist', 'mountain'],
    },
    '🚵‍♂️': {
        keywords: [],
    },
    '🚵‍♀️': {
        keywords: [],
    },
    '🤸': {
        keywords: ['cartwheel', 'gymnastics'],
    },
    '🤸‍♂️': {
        keywords: [],
    },
    '🤸‍♀️': {
        keywords: [],
    },
    '🤼': {
        keywords: ['wrestle', 'wrestler'],
    },
    '🤼‍♂️': {
        keywords: [],
    },
    '🤼‍♀️': {
        keywords: [],
    },
    '🤽': {
        keywords: ['polo', 'water'],
    },
    '🤽‍♂️': {
        keywords: [],
    },
    '🤽‍♀️': {
        keywords: [],
    },
    '🤾': {
        keywords: ['ball', 'handball'],
    },
    '🤾‍♂️': {
        keywords: [],
    },
    '🤾‍♀️': {
        keywords: [],
    },
    '🤹': {
        keywords: ['balance', 'juggle', 'multitask', 'skill'],
    },
    '🤹‍♂️': {
        keywords: [],
    },
    '🤹‍♀️': {
        keywords: [],
    },
    '🧘': {
        keywords: ['meditation'],
    },
    '🧘‍♂️': {
        keywords: ['meditation'],
    },
    '🧘‍♀️': {
        keywords: ['meditation'],
    },
    '🛀': {
        keywords: ['shower', 'bathtub'],
    },
    '🛌': {
        keywords: ['hotel', 'sleep'],
    },
    '🧑‍🤝‍🧑': {
        keywords: ['couple', 'date'],
    },
    '👭': {
        keywords: ['couple', 'date', 'hand', 'hold', 'woman'],
    },
    '👫': {
        keywords: ['date', 'hand', 'hold', 'man', 'woman'],
    },
    '👬': {
        keywords: ['couple', 'date', 'gemini', 'hand', 'hold', 'man', 'twins', 'zodiac'],
    },
    '💏': {
        keywords: ['couple', 'kiss', 'romance'],
    },
    '👩‍❤️‍💋‍👨': {
        keywords: [],
    },
    '👨‍❤️‍💋‍👨': {
        keywords: [],
    },
    '👩‍❤️‍💋‍👩': {
        keywords: [],
    },
    '💑': {
        keywords: ['couple', 'heart', 'love', 'romance'],
    },
    '👩‍❤️‍👨': {
        keywords: [],
    },
    '👨‍❤️‍👨': {
        keywords: [],
    },
    '👩‍❤️‍👩': {
        keywords: [],
    },
    '👪': {
        keywords: ['home', 'parents', 'child', 'father', 'mother'],
    },
    '👨‍👩‍👦': {
        keywords: ['boy', 'family', 'man', 'woman'],
    },
    '👨‍👩‍👧': {
        keywords: ['family', 'girl', 'man', 'woman'],
    },
    '👨‍👩‍👧‍👦': {
        keywords: ['boy', 'family', 'girl', 'man', 'woman'],
    },
    '👨‍👩‍👦‍👦': {
        keywords: ['boy', 'family', 'man', 'woman'],
    },
    '👨‍👩‍👧‍👧': {
        keywords: ['family', 'girl', 'man', 'woman'],
    },
    '👨‍👨‍👦': {
        keywords: ['boy', 'family', 'man'],
    },
    '👨‍👨‍👧': {
        keywords: ['family', 'girl', 'man'],
    },
    '👨‍👨‍👧‍👦': {
        keywords: ['boy', 'family', 'girl', 'man'],
    },
    '👨‍👨‍👦‍👦': {
        keywords: ['boy', 'family', 'man'],
    },
    '👨‍👨‍👧‍👧': {
        keywords: ['family', 'girl', 'man'],
    },
    '👩‍👩‍👦': {
        keywords: ['boy', 'family', 'woman'],
    },
    '👩‍👩‍👧': {
        keywords: ['family', 'girl', 'woman'],
    },
    '👩‍👩‍👧‍👦': {
        keywords: ['boy', 'family', 'girl', 'woman'],
    },
    '👩‍👩‍👦‍👦': {
        keywords: ['boy', 'family', 'woman'],
    },
    '👩‍👩‍👧‍👧': {
        keywords: ['family', 'girl', 'woman'],
    },
    '👨‍👦': {
        keywords: [],
    },
    '👨‍👦‍👦': {
        keywords: [],
    },
    '👨‍👧': {
        keywords: [],
    },
    '👨‍👧‍👦': {
        keywords: [],
    },
    '👨‍👧‍👧': {
        keywords: [],
    },
    '👩‍👦': {
        keywords: [],
    },
    '👩‍👦‍👦': {
        keywords: [],
    },
    '👩‍👧': {
        keywords: [],
    },
    '👩‍👧‍👦': {
        keywords: [],
    },
    '👩‍👧‍👧': {
        keywords: [],
    },
    '🗣️': {
        keywords: [],
    },
    '👤': {
        keywords: ['user', 'bust', 'silhouette'],
    },
    '👥': {
        keywords: ['users', 'group', 'team', 'bust', 'silhouette'],
    },
    '🫂': {
        keywords: [],
    },
    '👣': {
        keywords: ['feet', 'tracks', 'body', 'clothing', 'footprint', 'print'],
    },
    '🐵': {
        keywords: ['face', 'monkey'],
    },
    '🐒': {
        keywords: [],
    },
    '🦍': {
        keywords: [],
    },
    '🦧': {
        keywords: [],
    },
    '🐶': {
        keywords: ['pet', 'face'],
    },
    '🐕': {
        keywords: ['dog', 'pet'],
    },
    '🦮': {
        keywords: [],
    },
    '🐕‍🦺': {
        keywords: [],
    },
    '🐩': {
        keywords: ['dog'],
    },
    '🐺': {
        keywords: ['face'],
    },
    '🦊': {
        keywords: ['face', 'fox'],
    },
    '🦝': {
        keywords: [],
    },
    '🐱': {
        keywords: ['pet', 'face'],
    },
    '🐈': {
        keywords: ['cat', 'pet'],
    },
    '🐈‍⬛': {
        keywords: [],
    },
    '🦁': {
        keywords: ['face', 'leo', 'zodiac'],
    },
    '🐯': {
        keywords: ['face'],
    },
    '🐅': {
        keywords: ['tiger'],
    },
    '🐆': {
        keywords: [],
    },
    '🐴': {
        keywords: ['face'],
    },
    '🐎': {
        keywords: ['speed', 'horse', 'racing'],
    },
    '🦄': {
        keywords: ['face'],
    },
    '🦓': {
        keywords: [],
    },
    '🦌': {
        keywords: [],
    },
    '🦬': {
        keywords: [],
    },
    '🐮': {
        keywords: ['face'],
    },
    '🐂': {
        keywords: ['bull', 'taurus', 'zodiac'],
    },
    '🐃': {
        keywords: ['buffalo', 'water'],
    },
    '🐄': {
        keywords: ['cow'],
    },
    '🐷': {
        keywords: ['face'],
    },
    '🐖': {
        keywords: ['pig', 'sow'],
    },
    '🐗': {
        keywords: ['pig'],
    },
    '🐽': {
        keywords: ['face', 'nose', 'pig'],
    },
    '🐏': {
        keywords: ['aries', 'sheep', 'zodiac'],
    },
    '🐑': {
        keywords: ['ewe'],
    },
    '🐐': {
        keywords: ['capricorn', 'zodiac'],
    },
    '🐪': {
        keywords: ['desert', 'camel', 'dromedary', 'hump'],
    },
    '🐫': {
        keywords: ['bactrian', 'hump'],
    },
    '🦙': {
        keywords: [],
    },
    '🦒': {
        keywords: [],
    },
    '🐘': {
        keywords: [],
    },
    '🦣': {
        keywords: [],
    },
    '🦏': {
        keywords: [],
    },
    '🦛': {
        keywords: [],
    },
    '🐭': {
        keywords: ['face'],
    },
    '🐁': {
        keywords: ['mouse'],
    },
    '🐀': {
        keywords: [],
    },
    '🐹': {
        keywords: ['pet', 'face'],
    },
    '🐰': {
        keywords: ['bunny', 'face', 'pet'],
    },
    '🐇': {
        keywords: ['bunny', 'pet', 'rabbit'],
    },
    '🐿️': {
        keywords: [],
    },
    '🦫': {
        keywords: [],
    },
    '🦔': {
        keywords: [],
    },
    '🦇': {
        keywords: ['vampire'],
    },
    '🐻': {
        keywords: ['face'],
    },
    '🐻‍❄️': {
        keywords: [],
    },
    '🐨': {
        keywords: ['bear'],
    },
    '🐼': {
        keywords: ['face', 'panda'],
    },
    '🦥': {
        keywords: [],
    },
    '🦦': {
        keywords: [],
    },
    '🦨': {
        keywords: [],
    },
    '🦘': {
        keywords: [],
    },
    '🦡': {
        keywords: [],
    },
    '🐾': {
        keywords: ['paw_prints', 'paw', 'print'],
    },
    '🦃': {
        keywords: ['thanksgiving'],
    },
    '🐔': {
        keywords: [],
    },
    '🐓': {
        keywords: [],
    },
    '🐣': {
        keywords: ['baby', 'chick', 'hatching'],
    },
    '🐤': {
        keywords: ['baby', 'chick'],
    },
    '🐥': {
        keywords: ['baby', 'chick'],
    },
    '🐦': {
        keywords: [],
    },
    '🐧': {
        keywords: [],
    },
    '🕊️': {
        keywords: ['peace'],
    },
    '🦅': {
        keywords: ['bird'],
    },
    '🦆': {
        keywords: ['bird'],
    },
    '🦢': {
        keywords: [],
    },
    '🦉': {
        keywords: ['bird', 'wise'],
    },
    '🦤': {
        keywords: [],
    },
    '🪶': {
        keywords: [],
    },
    '🦩': {
        keywords: [],
    },
    '🦚': {
        keywords: [],
    },
    '🦜': {
        keywords: [],
    },
    '🐸': {
        keywords: ['face'],
    },
    '🐊': {
        keywords: [],
    },
    '🐢': {
        keywords: ['slow'],
    },
    '🦎': {
        keywords: ['reptile'],
    },
    '🐍': {
        keywords: ['bearer', 'ophiuchus', 'serpent', 'zodiac'],
    },
    '🐲': {
        keywords: ['dragon', 'face', 'fairy tale'],
    },
    '🐉': {
        keywords: ['fairy tale'],
    },
    '🦕': {
        keywords: ['dinosaur'],
    },
    '🦖': {
        keywords: ['dinosaur'],
    },
    '🐳': {
        keywords: ['sea', 'face', 'spouting'],
    },
    '🐋': {
        keywords: ['whale'],
    },
    '🐬': {
        keywords: ['flipper'],
    },
    '🦭': {
        keywords: [],
    },
    '🐟': {
        keywords: ['pisces', 'zodiac'],
    },
    '🐠': {
        keywords: ['fish', 'tropical'],
    },
    '🐡': {
        keywords: ['fish'],
    },
    '🦈': {
        keywords: ['fish'],
    },
    '🐙': {
        keywords: [],
    },
    '🐚': {
        keywords: ['sea', 'beach', 'spiral'],
    },
    '🐌': {
        keywords: ['slow'],
    },
    '🦋': {
        keywords: ['insect', 'pretty'],
    },
    '🐛': {
        keywords: ['insect'],
    },
    '🐜': {
        keywords: ['insect'],
    },
    '🐝': {
        keywords: ['honeybee', 'insect'],
    },
    '🪲': {
        keywords: [],
    },
    '🐞': {
        keywords: ['bug', 'beetle', 'insect', 'lady beetle', 'ladybird', 'ladybug'],
    },
    '🦗': {
        keywords: [],
    },
    '🪳': {
        keywords: [],
    },
    '🕷️': {
        keywords: [],
    },
    '🕸️': {
        keywords: [],
    },
    '🦂': {
        keywords: ['scorpio', 'scorpius', 'zodiac'],
    },
    '🦟': {
        keywords: [],
    },
    '🪰': {
        keywords: [],
    },
    '🪱': {
        keywords: [],
    },
    '🦠': {
        keywords: ['germ'],
    },
    '💐': {
        keywords: ['flowers', 'flower', 'plant', 'romance'],
    },
    '🌸': {
        keywords: ['flower', 'spring', 'blossom', 'cherry', 'plant'],
    },
    '💮': {
        keywords: ['flower'],
    },
    '🏵️': {
        keywords: [],
    },
    '🌹': {
        keywords: ['flower', 'plant'],
    },
    '🥀': {
        keywords: ['flower', 'wilted'],
    },
    '🌺': {
        keywords: ['flower', 'plant'],
    },
    '🌻': {
        keywords: ['flower', 'plant', 'sun'],
    },
    '🌼': {
        keywords: ['flower', 'plant'],
    },
    '🌷': {
        keywords: ['flower', 'plant'],
    },
    '🌱': {
        keywords: ['plant', 'young'],
    },
    '🪴': {
        keywords: [],
    },
    '🌲': {
        keywords: ['wood', 'evergreen', 'plant', 'tree'],
    },
    '🌳': {
        keywords: ['wood', 'deciduous', 'plant', 'shedding', 'tree'],
    },
    '🌴': {
        keywords: ['palm', 'plant', 'tree'],
    },
    '🌵': {
        keywords: ['plant'],
    },
    '🌾': {
        keywords: ['ear', 'plant', 'rice'],
    },
    '🌿': {
        keywords: ['leaf', 'plant'],
    },
    '☘️': {
        keywords: ['plant'],
    },
    '🍀': {
        keywords: ['luck', '4', 'clover', 'four', 'leaf', 'plant'],
    },
    '🍁': {
        keywords: ['canada', 'falling', 'leaf', 'maple', 'plant'],
    },
    '🍂': {
        keywords: ['autumn', 'falling', 'leaf', 'plant'],
    },
    '🍃': {
        keywords: ['leaf', 'blow', 'flutter', 'plant', 'wind'],
    },
    '🍇': {
        keywords: ['fruit', 'grape', 'plant'],
    },
    '🍈': {
        keywords: ['fruit', 'plant'],
    },
    '🍉': {
        keywords: ['fruit', 'plant'],
    },
    '🍊': {
        keywords: ['orange', 'mandarin', 'fruit', 'plant'],
    },
    '🍋': {
        keywords: ['citrus', 'fruit', 'plant'],
    },
    '🍌': {
        keywords: ['fruit', 'plant'],
    },
    '🍍': {
        keywords: ['fruit', 'plant'],
    },
    '🥭': {
        keywords: [],
    },
    '🍎': {
        keywords: ['fruit', 'plant', 'red'],
    },
    '🍏': {
        keywords: ['fruit', 'apple', 'green', 'plant'],
    },
    '🍐': {
        keywords: ['fruit', 'plant'],
    },
    '🍑': {
        keywords: ['fruit', 'plant'],
    },
    '🍒': {
        keywords: ['fruit', 'cherry', 'plant'],
    },
    '🍓': {
        keywords: ['fruit', 'berry', 'plant'],
    },
    '🫐': {
        keywords: [],
    },
    '🥝': {
        keywords: ['fruit', 'kiwi'],
    },
    '🍅': {
        keywords: ['plant', 'vegetable'],
    },
    '🫒': {
        keywords: [],
    },
    '🥥': {
        keywords: [],
    },
    '🥑': {
        keywords: ['fruit'],
    },
    '🍆': {
        keywords: ['aubergine', 'plant', 'vegetable'],
    },
    '🥔': {
        keywords: ['vegetable'],
    },
    '🥕': {
        keywords: ['vegetable'],
    },
    '🌽': {
        keywords: ['ear', 'maize', 'maze', 'plant'],
    },
    '🌶️': {
        keywords: ['spicy'],
    },
    '🫑': {
        keywords: [],
    },
    '🥒': {
        keywords: ['pickle', 'vegetable'],
    },
    '🥬': {
        keywords: [],
    },
    '🥦': {
        keywords: [],
    },
    '🧄': {
        keywords: [],
    },
    '🧅': {
        keywords: [],
    },
    '🍄': {
        keywords: ['plant'],
    },
    '🥜': {
        keywords: ['nut', 'peanut', 'vegetable'],
    },
    '🌰': {
        keywords: ['plant'],
    },
    '🍞': {
        keywords: ['toast', 'loaf'],
    },
    '🥐': {
        keywords: ['bread', 'crescent roll', 'french'],
    },
    '🥖': {
        keywords: ['baguette', 'bread', 'french'],
    },
    '🫓': {
        keywords: [],
    },
    '🥨': {
        keywords: [],
    },
    '🥯': {
        keywords: [],
    },
    '🥞': {
        keywords: ['crêpe', 'hotcake', 'pancake'],
    },
    '🧇': {
        keywords: [],
    },
    '🧀': {
        keywords: [],
    },
    '🍖': {
        keywords: ['bone', 'meat'],
    },
    '🍗': {
        keywords: ['meat', 'chicken', 'bone', 'leg', 'poultry'],
    },
    '🥩': {
        keywords: [],
    },
    '🥓': {
        keywords: ['meat'],
    },
    '🍔': {
        keywords: ['burger'],
    },
    '🍟': {
        keywords: ['french'],
    },
    '🍕': {
        keywords: ['cheese', 'slice'],
    },
    '🌭': {
        keywords: ['frankfurter', 'hot dog', 'sausage'],
    },
    '🥪': {
        keywords: [],
    },
    '🌮': {
        keywords: ['mexican'],
    },
    '🌯': {
        keywords: ['mexican'],
    },
    '🫔': {
        keywords: [],
    },
    '🥙': {
        keywords: ['falafel', 'flatbread', 'gyro', 'kebab', 'stuffed'],
    },
    '🧆': {
        keywords: [],
    },
    '🥚': {
        keywords: [],
    },
    '🍳': {
        keywords: ['breakfast', 'cooking', 'egg', 'frying', 'pan'],
    },
    '🥘': {
        keywords: ['paella', 'curry', 'casserole', 'pan', 'shallow'],
    },
    '🍲': {
        keywords: ['pot'],
    },
    '🫕': {
        keywords: [],
    },
    '🥣': {
        keywords: [],
    },
    '🥗': {
        keywords: ['green', 'salad'],
    },
    '🍿': {
        keywords: [],
    },
    '🧈': {
        keywords: [],
    },
    '🧂': {
        keywords: [],
    },
    '🥫': {
        keywords: [],
    },
    '🍱': {
        keywords: ['box'],
    },
    '🍘': {
        keywords: ['cracker', 'rice'],
    },
    '🍙': {
        keywords: ['ball', 'japanese', 'rice'],
    },
    '🍚': {
        keywords: ['cooked'],
    },
    '🍛': {
        keywords: ['rice'],
    },
    '🍜': {
        keywords: ['noodle', 'bowl', 'steaming'],
    },
    '🍝': {
        keywords: ['pasta'],
    },
    '🍠': {
        keywords: ['potato', 'roasted', 'sweet'],
    },
    '🍢': {
        keywords: ['kebab', 'seafood', 'skewer', 'stick'],
    },
    '🍣': {
        keywords: [],
    },
    '🍤': {
        keywords: ['tempura', 'fried', 'prawn', 'shrimp'],
    },
    '🍥': {
        keywords: ['cake', 'fish', 'pastry', 'swirl'],
    },
    '🥮': {
        keywords: [],
    },
    '🍡': {
        keywords: ['dessert', 'japanese', 'skewer', 'stick', 'sweet'],
    },
    '🥟': {
        keywords: [],
    },
    '🥠': {
        keywords: [],
    },
    '🥡': {
        keywords: [],
    },
    '🦀': {
        keywords: ['cancer', 'zodiac'],
    },
    '🦞': {
        keywords: [],
    },
    '🦐': {
        keywords: ['shellfish', 'small'],
    },
    '🦑': {
        keywords: ['molusc'],
    },
    '🦪': {
        keywords: [],
    },
    '🍦': {
        keywords: ['cream', 'dessert', 'ice', 'soft', 'sweet'],
    },
    '🍧': {
        keywords: ['dessert', 'ice', 'shaved', 'sweet'],
    },
    '🍨': {
        keywords: ['cream', 'dessert', 'ice', 'sweet'],
    },
    '🍩': {
        keywords: ['dessert', 'donut', 'sweet'],
    },
    '🍪': {
        keywords: ['dessert', 'sweet'],
    },
    '🎂': {
        keywords: ['party', 'cake', 'celebration', 'dessert', 'pastry', 'sweet'],
    },
    '🍰': {
        keywords: ['dessert', 'pastry', 'shortcake', 'slice', 'sweet'],
    },
    '🧁': {
        keywords: [],
    },
    '🥧': {
        keywords: [],
    },
    '🍫': {
        keywords: ['bar', 'chocolate', 'dessert', 'sweet'],
    },
    '🍬': {
        keywords: ['sweet', 'dessert'],
    },
    '🍭': {
        keywords: ['candy', 'dessert', 'sweet'],
    },
    '🍮': {
        keywords: ['dessert', 'pudding', 'sweet'],
    },
    '🍯': {
        keywords: ['honey', 'honeypot', 'pot', 'sweet'],
    },
    '🍼': {
        keywords: ['milk', 'baby', 'bottle', 'drink'],
    },
    '🥛': {
        keywords: ['drink', 'glass', 'milk'],
    },
    '☕': {
        keywords: ['cafe', 'espresso', 'beverage', 'drink', 'hot', 'steaming', 'tea'],
    },
    '🫖': {
        keywords: [],
    },
    '🍵': {
        keywords: ['green', 'breakfast', 'beverage', 'cup', 'drink', 'teacup'],
    },
    '🍶': {
        keywords: ['bar', 'beverage', 'bottle', 'cup', 'drink'],
    },
    '🍾': {
        keywords: ['bottle', 'bubbly', 'celebration', 'bar', 'cork', 'drink', 'popping'],
    },
    '🍷': {
        keywords: ['bar', 'beverage', 'drink', 'glass', 'wine'],
    },
    '🍸': {
        keywords: ['drink', 'bar', 'glass'],
    },
    '🍹': {
        keywords: ['summer', 'vacation', 'bar', 'drink', 'tropical'],
    },
    '🍺': {
        keywords: ['drink', 'bar', 'mug'],
    },
    '🍻': {
        keywords: ['drinks', 'bar', 'beer', 'clink', 'drink', 'mug'],
    },
    '🥂': {
        keywords: ['cheers', 'toast', 'celebrate', 'clink', 'drink', 'glass'],
    },
    '🥃': {
        keywords: ['whisky', 'glass', 'liquor', 'shot', 'tumbler'],
    },
    '🥤': {
        keywords: [],
    },
    '🧋': {
        keywords: [],
    },
    '🧃': {
        keywords: [],
    },
    '🧉': {
        keywords: [],
    },
    '🧊': {
        keywords: [],
    },
    '🥢': {
        keywords: [],
    },
    '🍽️': {
        keywords: ['dining', 'dinner'],
    },
    '🍴': {
        keywords: ['cutlery', 'cooking', 'fork', 'knife'],
    },
    '🥄': {
        keywords: ['tableware'],
    },
    '🔪': {
        keywords: ['cut', 'chop', 'knife', 'cooking', 'tool', 'weapon'],
    },
    '🏺': {
        keywords: ['aquarius', 'cooking', 'drink', 'jug', 'tool', 'weapon', 'zodiac'],
    },
    '🌍': {
        keywords: ['globe', 'world', 'international', 'africa', 'earth', 'europe'],
    },
    '🌎': {
        keywords: ['globe', 'world', 'international', 'americas', 'earth'],
    },
    '🌏': {
        keywords: ['globe', 'world', 'international', 'asia', 'australia', 'earth'],
    },
    '🌐': {
        keywords: ['world', 'global', 'international', 'earth', 'globe', 'meridians'],
    },
    '🗺️': {
        keywords: ['travel'],
    },
    '🗾': {
        keywords: ['map'],
    },
    '🧭': {
        keywords: [],
    },
    '🏔️': {
        keywords: [],
    },
    '⛰️': {
        keywords: [],
    },
    '🌋': {
        keywords: ['eruption', 'mountain', 'weather'],
    },
    '🗻': {
        keywords: ['fuji', 'mountain'],
    },
    '🏕️': {
        keywords: [],
    },
    '🏖️': {
        keywords: [],
    },
    '🏜️': {
        keywords: [],
    },
    '🏝️': {
        keywords: [],
    },
    '🏞️': {
        keywords: [],
    },
    '🏟️': {
        keywords: [],
    },
    '🏛️': {
        keywords: [],
    },
    '🏗️': {
        keywords: [],
    },
    '🧱': {
        keywords: [],
    },
    '🪨': {
        keywords: [],
    },
    '🪵': {
        keywords: [],
    },
    '🛖': {
        keywords: [],
    },
    '🏘️': {
        keywords: [],
    },
    '🏚️': {
        keywords: [],
    },
    '🏠': {
        keywords: ['building', 'home'],
    },
    '🏡': {
        keywords: ['building', 'garden', 'home', 'house'],
    },
    '🏢': {
        keywords: ['building'],
    },
    '🏣': {
        keywords: ['building', 'japanese', 'post'],
    },
    '🏤': {
        keywords: ['building', 'european', 'post'],
    },
    '🏥': {
        keywords: ['building', 'doctor', 'medicine'],
    },
    '🏦': {
        keywords: ['building'],
    },
    '🏨': {
        keywords: ['building'],
    },
    '🏩': {
        keywords: ['building', 'hotel', 'love'],
    },
    '🏪': {
        keywords: ['building', 'convenience', 'store'],
    },
    '🏫': {
        keywords: ['building'],
    },
    '🏬': {
        keywords: ['building', 'department', 'store'],
    },
    '🏭': {
        keywords: ['building'],
    },
    '🏯': {
        keywords: ['building', 'castle', 'japanese'],
    },
    '🏰': {
        keywords: ['building', 'castle', 'european'],
    },
    '💒': {
        keywords: ['marriage', 'activity', 'chapel', 'romance'],
    },
    '🗼': {
        keywords: ['tokyo', 'tower'],
    },
    '🗽': {
        keywords: ['liberty', 'statue'],
    },
    '⛪': {
        keywords: ['building', 'christian', 'cross', 'religion'],
    },
    '🕌': {
        keywords: ['islam', 'muslim', 'religion'],
    },
    '🛕': {
        keywords: [],
    },
    '🕍': {
        keywords: ['jew', 'jewish', 'religion', 'temple'],
    },
    '⛩️': {
        keywords: [],
    },
    '🕋': {
        keywords: ['islam', 'muslim', 'religion'],
    },
    '⛲': {
        keywords: [],
    },
    '⛺': {
        keywords: ['camping'],
    },
    '🌁': {
        keywords: ['karl', 'fog', 'weather'],
    },
    '🌃': {
        keywords: ['night', 'star', 'weather'],
    },
    '🏙️': {
        keywords: ['skyline'],
    },
    '🌄': {
        keywords: ['morning', 'mountain', 'sun', 'sunrise', 'weather'],
    },
    '🌅': {
        keywords: ['morning', 'sun', 'weather'],
    },
    '🌆': {
        keywords: ['building', 'city', 'dusk', 'evening', 'landscape', 'sun', 'sunset', 'weather'],
    },
    '🌇': {
        keywords: ['building', 'dusk', 'sun', 'sunset', 'weather'],
    },
    '🌉': {
        keywords: ['bridge', 'night', 'weather'],
    },
    '♨️': {
        keywords: ['hot', 'springs', 'steaming'],
    },
    '🎠': {
        keywords: ['activity', 'carousel', 'entertainment', 'horse'],
    },
    '🎡': {
        keywords: ['activity', 'amusement park', 'entertainment', 'ferris', 'wheel'],
    },
    '🎢': {
        keywords: ['activity', 'amusement park', 'coaster', 'entertainment', 'roller'],
    },
    '💈': {
        keywords: ['haircut', 'pole'],
    },
    '🎪': {
        keywords: ['activity', 'circus', 'entertainment', 'tent'],
    },
    '🚂': {
        keywords: ['train', 'engine', 'locomotive', 'railway', 'steam', 'vehicle'],
    },
    '🚃': {
        keywords: ['car', 'electric', 'railway', 'train', 'tram', 'trolleybus', 'vehicle'],
    },
    '🚄': {
        keywords: ['train', 'railway', 'shinkansen', 'speed', 'vehicle'],
    },
    '🚅': {
        keywords: ['train', 'bullet', 'railway', 'shinkansen', 'speed', 'vehicle'],
    },
    '🚆': {
        keywords: ['railway', 'train', 'vehicle'],
    },
    '🚇': {
        keywords: ['subway', 'vehicle'],
    },
    '🚈': {
        keywords: ['railway', 'vehicle'],
    },
    '🚉': {
        keywords: ['railway', 'train', 'vehicle'],
    },
    '🚊': {
        keywords: ['trolleybus', 'vehicle'],
    },
    '🚝': {
        keywords: ['vehicle'],
    },
    '🚞': {
        keywords: ['car', 'mountain', 'railway', 'vehicle'],
    },
    '🚋': {
        keywords: ['car', 'tram', 'trolleybus', 'vehicle'],
    },
    '🚌': {
        keywords: ['vehicle'],
    },
    '🚍': {
        keywords: ['bus', 'oncoming', 'vehicle'],
    },
    '🚎': {
        keywords: ['bus', 'tram', 'trolley', 'vehicle'],
    },
    '🚐': {
        keywords: ['bus', 'vehicle'],
    },
    '🚑': {
        keywords: ['vehicle'],
    },
    '🚒': {
        keywords: ['engine', 'fire', 'truck', 'vehicle'],
    },
    '🚓': {
        keywords: ['car', 'patrol', 'police', 'vehicle'],
    },
    '🚔': {
        keywords: ['car', 'oncoming', 'police', 'vehicle'],
    },
    '🚕': {
        keywords: ['vehicle'],
    },
    '🚖': {
        keywords: ['oncoming', 'taxi', 'vehicle'],
    },
    '🚗': {
        keywords: ['red_car', 'automobile', 'vehicle'],
    },
    '🚘': {
        keywords: ['automobile', 'car', 'oncoming', 'vehicle'],
    },
    '🚙': {
        keywords: ['recreational', 'rv', 'vehicle'],
    },
    '🛻': {
        keywords: [],
    },
    '🚚': {
        keywords: ['delivery', 'vehicle'],
    },
    '🚛': {
        keywords: ['lorry', 'semi', 'truck', 'vehicle'],
    },
    '🚜': {
        keywords: ['vehicle'],
    },
    '🏎️': {
        keywords: [],
    },
    '🏍️': {
        keywords: [],
    },
    '🛵': {
        keywords: ['motor', 'scooter'],
    },
    '🦽': {
        keywords: [],
    },
    '🦼': {
        keywords: [],
    },
    '🛺': {
        keywords: [],
    },
    '🚲': {
        keywords: ['bicycle', 'vehicle'],
    },
    '🛴': {
        keywords: ['kick', 'scooter'],
    },
    '🛹': {
        keywords: [],
    },
    '🛼': {
        keywords: [],
    },
    '🚏': {
        keywords: ['bus', 'stop'],
    },
    '🛣️': {
        keywords: [],
    },
    '🛤️': {
        keywords: [],
    },
    '🛢️': {
        keywords: [],
    },
    '⛽': {
        keywords: ['fuel', 'gas', 'pump', 'station'],
    },
    '🚨': {
        keywords: ['911', 'emergency', 'beacon', 'car', 'light', 'police', 'revolving', 'vehicle'],
    },
    '🚥': {
        keywords: ['light', 'signal', 'traffic'],
    },
    '🚦': {
        keywords: ['semaphore', 'light', 'signal', 'traffic'],
    },
    '🛑': {
        keywords: ['octagonal', 'stop'],
    },
    '🚧': {
        keywords: ['wip', 'barrier'],
    },
    '⚓': {
        keywords: ['ship', 'tool'],
    },
    '⛵': {
        keywords: ['sailboat', 'resort', 'sea', 'vehicle', 'yacht'],
    },
    '🛶': {
        keywords: ['boat'],
    },
    '🚤': {
        keywords: ['ship', 'boat', 'vehicle'],
    },
    '🛳️': {
        keywords: ['cruise'],
    },
    '⛴️': {
        keywords: [],
    },
    '🛥️': {
        keywords: [],
    },
    '🚢': {
        keywords: ['vehicle'],
    },
    '✈️': {
        keywords: ['flight', 'vehicle'],
    },
    '🛩️': {
        keywords: ['flight'],
    },
    '🛫': {
        keywords: ['airplane', 'check-in', 'departure', 'departures', 'vehicle'],
    },
    '🛬': {
        keywords: ['airplane', 'arrivals', 'arriving', 'landing', 'vehicle'],
    },
    '🪂': {
        keywords: [],
    },
    '💺': {
        keywords: ['chair'],
    },
    '🚁': {
        keywords: ['vehicle'],
    },
    '🚟': {
        keywords: ['railway', 'suspension', 'vehicle'],
    },
    '🚠': {
        keywords: ['cable', 'gondola', 'mountain', 'vehicle'],
    },
    '🚡': {
        keywords: ['aerial', 'cable', 'car', 'gondola', 'ropeway', 'tramway', 'vehicle'],
    },
    '🛰️': {
        keywords: ['orbit', 'space'],
    },
    '🚀': {
        keywords: ['ship', 'launch', 'space', 'vehicle'],
    },
    '🛸': {
        keywords: ['ufo'],
    },
    '🛎️': {
        keywords: [],
    },
    '🧳': {
        keywords: [],
    },
    '⌛': {
        keywords: ['time', 'sand', 'timer'],
    },
    '⏳': {
        keywords: ['time', 'hourglass', 'sand', 'timer'],
    },
    '⌚': {
        keywords: ['time', 'clock'],
    },
    '⏰': {
        keywords: ['morning', 'alarm', 'clock'],
    },
    '⏱️': {
        keywords: [],
    },
    '⏲️': {
        keywords: [],
    },
    '🕰️': {
        keywords: [],
    },
    '🕛': {
        keywords: ['00', '12', '12:00', 'clock', 'o’clock', 'twelve'],
    },
    '🕧': {
        keywords: ['12', '12:30', '30', 'clock', 'thirty', 'twelve'],
    },
    '🕐': {
        keywords: ['00', '1', '1:00', 'clock', 'o’clock', 'one'],
    },
    '🕜': {
        keywords: ['1', '1:30', '30', 'clock', 'one', 'thirty'],
    },
    '🕑': {
        keywords: ['00', '2', '2:00', 'clock', 'o’clock', 'two'],
    },
    '🕝': {
        keywords: ['2', '2:30', '30', 'clock', 'thirty', 'two'],
    },
    '🕒': {
        keywords: ['00', '3', '3:00', 'clock', 'o’clock', 'three'],
    },
    '🕞': {
        keywords: ['3', '3:30', '30', 'clock', 'thirty', 'three'],
    },
    '🕓': {
        keywords: ['00', '4', '4:00', 'clock', 'four', 'o’clock'],
    },
    '🕟': {
        keywords: ['30', '4', '4:30', 'clock', 'four', 'thirty'],
    },
    '🕔': {
        keywords: ['00', '5', '5:00', 'clock', 'five', 'o’clock'],
    },
    '🕠': {
        keywords: ['30', '5', '5:30', 'clock', 'five', 'thirty'],
    },
    '🕕': {
        keywords: ['00', '6', '6:00', 'clock', 'o’clock', 'six'],
    },
    '🕡': {
        keywords: ['30', '6', '6:30', 'clock', 'six', 'thirty'],
    },
    '🕖': {
        keywords: ['00', '7', '7:00', 'clock', 'o’clock', 'seven'],
    },
    '🕢': {
        keywords: ['30', '7', '7:30', 'clock', 'seven', 'thirty'],
    },
    '🕗': {
        keywords: ['00', '8', '8:00', 'clock', 'eight', 'o’clock'],
    },
    '🕣': {
        keywords: ['30', '8', '8:30', 'clock', 'eight', 'thirty'],
    },
    '🕘': {
        keywords: ['00', '9', '9:00', 'clock', 'nine', 'o’clock'],
    },
    '🕤': {
        keywords: ['30', '9', '9:30', 'clock', 'nine', 'thirty'],
    },
    '🕙': {
        keywords: ['00', '10', '10:00', 'clock', 'o’clock', 'ten'],
    },
    '🕥': {
        keywords: ['10', '10:30', '30', 'clock', 'ten', 'thirty'],
    },
    '🕚': {
        keywords: ['00', '11', '11:00', 'clock', 'eleven', 'o’clock'],
    },
    '🕦': {
        keywords: ['11', '11:30', '30', 'clock', 'eleven', 'thirty'],
    },
    '🌑': {
        keywords: ['dark', 'moon', 'space', 'weather'],
    },
    '🌒': {
        keywords: ['crescent', 'moon', 'space', 'waxing', 'weather'],
    },
    '🌓': {
        keywords: ['moon', 'quarter', 'space', 'weather'],
    },
    '🌔': {
        keywords: ['waxing_gibbous_moon', 'gibbous', 'space', 'waxing', 'weather'],
    },
    '🌕': {
        keywords: ['full', 'moon', 'space', 'weather'],
    },
    '🌖': {
        keywords: ['gibbous', 'moon', 'space', 'waning', 'weather'],
    },
    '🌗': {
        keywords: ['moon', 'quarter', 'space', 'weather'],
    },
    '🌘': {
        keywords: ['crescent', 'moon', 'space', 'waning', 'weather'],
    },
    '🌙': {
        keywords: ['night', 'crescent', 'moon', 'space', 'weather'],
    },
    '🌚': {
        keywords: ['face', 'moon', 'space', 'weather'],
    },
    '🌛': {
        keywords: ['face', 'moon', 'quarter', 'space', 'weather'],
    },
    '🌜': {
        keywords: ['face', 'moon', 'quarter', 'space', 'weather'],
    },
    '🌡️': {
        keywords: [],
    },
    '☀️': {
        keywords: ['weather', 'bright', 'rays', 'space', 'sun'],
    },
    '🌝': {
        keywords: ['bright', 'face', 'full', 'moon', 'space', 'weather'],
    },
    '🌞': {
        keywords: ['summer', 'bright', 'face', 'space', 'sun', 'weather'],
    },
    '🪐': {
        keywords: [],
    },
    '⭐': {
        keywords: [],
    },
    '🌟': {
        keywords: ['glittery', 'glow', 'shining', 'sparkle', 'star'],
    },
    '🌠': {
        keywords: ['activity', 'falling', 'shooting', 'space', 'star'],
    },
    '🌌': {
        keywords: ['milky way', 'space', 'weather'],
    },
    '☁️': {
        keywords: ['weather'],
    },
    '⛅': {
        keywords: ['weather', 'cloud', 'sun'],
    },
    '⛈️': {
        keywords: [],
    },
    '🌤️': {
        keywords: [],
    },
    '🌥️': {
        keywords: [],
    },
    '🌦️': {
        keywords: [],
    },
    '🌧️': {
        keywords: [],
    },
    '🌨️': {
        keywords: [],
    },
    '🌩️': {
        keywords: [],
    },
    '🌪️': {
        keywords: [],
    },
    '🌫️': {
        keywords: [],
    },
    '🌬️': {
        keywords: [],
    },
    '🌀': {
        keywords: ['swirl', 'dizzy', 'twister', 'typhoon', 'weather'],
    },
    '🌈': {
        keywords: ['rain', 'weather'],
    },
    '🌂': {
        keywords: ['weather', 'rain', 'clothing', 'umbrella'],
    },
    '☂️': {
        keywords: ['clothing', 'rain', 'umbrella', 'weather'],
    },
    '☔': {
        keywords: ['rain', 'weather', 'clothing', 'drop'],
    },
    '⛱️': {
        keywords: ['beach_umbrella'],
    },
    '⚡': {
        keywords: ['lightning', 'thunder', 'danger', 'electric', 'electricity', 'voltage'],
    },
    '❄️': {
        keywords: ['winter', 'cold', 'weather', 'snow'],
    },
    '☃️': {
        keywords: ['winter', 'christmas', 'cold', 'snow', 'snowman', 'weather'],
    },
    '⛄': {
        keywords: ['winter', 'cold', 'snow', 'weather'],
    },
    '☄️': {
        keywords: ['space'],
    },
    '🔥': {
        keywords: ['burn', 'flame', 'tool'],
    },
    '💧': {
        keywords: ['water', 'cold', 'comic', 'drop', 'sweat', 'weather'],
    },
    '🌊': {
        keywords: ['sea', 'water', 'wave', 'weather'],
    },
    '🎃': {
        keywords: ['halloween', 'activity', 'celebration', 'entertainment', 'jack', 'lantern'],
    },
    '🎄': {
        keywords: ['activity', 'celebration', 'christmas', 'entertainment', 'tree'],
    },
    '🎆': {
        keywords: ['festival', 'celebration', 'activity', 'entertainment'],
    },
    '🎇': {
        keywords: ['activity', 'celebration', 'entertainment', 'fireworks', 'sparkle'],
    },
    '🧨': {
        keywords: [],
    },
    '✨': {
        keywords: ['shiny', 'entertainment', 'sparkle', 'star'],
    },
    '🎈': {
        keywords: ['party', 'birthday', 'activity', 'celebration', 'entertainment'],
    },
    '🎉': {
        keywords: ['hooray', 'party', 'activity', 'celebration', 'entertainment', 'popper'],
    },
    '🎊': {
        keywords: ['activity', 'ball', 'celebration', 'confetti', 'entertainment'],
    },
    '🎋': {
        keywords: ['activity', 'banner', 'celebration', 'entertainment', 'japanese', 'tree'],
    },
    '🎍': {
        keywords: ['activity', 'celebration', 'japanese', 'pine', 'plant'],
    },
    '🎎': {
        keywords: ['activity', 'celebration', 'doll', 'entertainment', 'festival', 'japanese'],
    },
    '🎏': {
        keywords: ['activity', 'carp', 'celebration', 'entertainment', 'flag', 'streamer'],
    },
    '🎐': {
        keywords: ['activity', 'bell', 'celebration', 'chime', 'entertainment', 'wind'],
    },
    '🎑': {
        keywords: ['activity', 'celebration', 'ceremony', 'entertainment', 'moon'],
    },
    '🧧': {
        keywords: [],
    },
    '🎀': {
        keywords: ['celebration'],
    },
    '🎁': {
        keywords: ['present', 'birthday', 'christmas', 'box', 'celebration', 'entertainment', 'wrapped'],
    },
    '🎗️': {
        keywords: [],
    },
    '🎟️': {
        keywords: [],
    },
    '🎫': {
        keywords: ['activity', 'admission', 'entertainment'],
    },
    '🎖️': {
        keywords: [],
    },
    '🏆': {
        keywords: ['award', 'contest', 'winner', 'prize'],
    },
    '🏅': {
        keywords: ['gold', 'winner', 'medal'],
    },
    '🥇': {
        keywords: ['gold', 'first', 'medal'],
    },
    '🥈': {
        keywords: ['silver', 'medal', 'second'],
    },
    '🥉': {
        keywords: ['bronze', 'medal', 'third'],
    },
    '⚽': {
        keywords: ['sports', 'ball'],
    },
    '⚾': {
        keywords: ['sports', 'ball'],
    },
    '🥎': {
        keywords: [],
    },
    '🏀': {
        keywords: ['sports', 'ball', 'hoop'],
    },
    '🏐': {
        keywords: ['ball', 'game'],
    },
    '🏈': {
        keywords: ['sports', 'american', 'ball'],
    },
    '🏉': {
        keywords: ['ball', 'football', 'rugby'],
    },
    '🎾': {
        keywords: ['sports', 'ball', 'racquet'],
    },
    '🥏': {
        keywords: [],
    },
    '🎳': {
        keywords: ['ball', 'game'],
    },
    '🏏': {
        keywords: ['ball', 'bat', 'cricket', 'game'],
    },
    '🏑': {
        keywords: ['ball', 'field', 'game', 'hockey', 'stick'],
    },
    '🏒': {
        keywords: ['game', 'hockey', 'ice', 'puck', 'stick'],
    },
    '🥍': {
        keywords: [],
    },
    '🏓': {
        keywords: ['ball', 'bat', 'game', 'paddle', 'table tennis'],
    },
    '🏸': {
        keywords: ['birdie', 'game', 'racquet', 'shuttlecock'],
    },
    '🥊': {
        keywords: ['boxing', 'glove'],
    },
    '🥋': {
        keywords: ['judo', 'karate', 'martial arts', 'taekwondo', 'uniform'],
    },
    '🥅': {
        keywords: ['goal', 'net'],
    },
    '⛳': {
        keywords: ['flag', 'hole'],
    },
    '⛸️': {
        keywords: ['skating'],
    },
    '🎣': {
        keywords: ['entertainment', 'fish', 'pole'],
    },
    '🤿': {
        keywords: [],
    },
    '🎽': {
        keywords: ['marathon', 'running', 'sash', 'shirt'],
    },
    '🎿': {
        keywords: ['snow'],
    },
    '🛷': {
        keywords: [],
    },
    '🥌': {
        keywords: [],
    },
    '🎯': {
        keywords: ['target', 'activity', 'bull', 'bullseye', 'entertainment', 'eye', 'game', 'hit'],
    },
    '🪀': {
        keywords: [],
    },
    '🪁': {
        keywords: [],
    },
    '🎱': {
        keywords: ['pool', 'billiards', '8', '8 ball', 'ball', 'billiard', 'eight', 'game'],
    },
    '🔮': {
        keywords: ['fortune', 'ball', 'crystal', 'fairy tale', 'fantasy', 'tool'],
    },
    '🪄': {
        keywords: [],
    },
    '🧿': {
        keywords: [],
    },
    '🎮': {
        keywords: ['play', 'controller', 'console', 'entertainment', 'game', 'video game'],
    },
    '🕹️': {
        keywords: [],
    },
    '🎰': {
        keywords: ['activity', 'game', 'slot'],
    },
    '🎲': {
        keywords: ['dice', 'gambling', 'die', 'entertainment', 'game'],
    },
    '🧩': {
        keywords: [],
    },
    '🧸': {
        keywords: [],
    },
    '🪅': {
        keywords: [],
    },
    '🪆': {
        keywords: [],
    },
    '♠️': {
        keywords: ['card', 'game', 'spade', 'suit'],
    },
    '♥️': {
        keywords: ['card', 'game', 'heart', 'suit'],
    },
    '♦️': {
        keywords: ['card', 'diamond', 'game', 'suit'],
    },
    '♣️': {
        keywords: ['card', 'club', 'game', 'suit'],
    },
    '♟️': {
        keywords: [],
    },
    '🃏': {
        keywords: ['card', 'entertainment', 'game', 'joker', 'playing'],
    },
    '🀄': {
        keywords: ['game', 'red'],
    },
    '🎴': {
        keywords: ['activity', 'card', 'entertainment', 'flower', 'game', 'japanese', 'playing'],
    },
    '🎭': {
        keywords: ['theater', 'drama', 'activity', 'art', 'entertainment', 'mask', 'performing', 'theatre'],
    },
    '🖼️': {
        keywords: [],
    },
    '🎨': {
        keywords: ['design', 'paint', 'activity', 'entertainment', 'museum', 'painting', 'palette'],
    },
    '🧵': {
        keywords: [],
    },
    '🪡': {
        keywords: [],
    },
    '🧶': {
        keywords: [],
    },
    '🪢': {
        keywords: [],
    },
    '👓': {
        keywords: ['glasses', 'clothing', 'eye', 'eyewear'],
    },
    '🕶️': {
        keywords: [],
    },
    '🥽': {
        keywords: [],
    },
    '🥼': {
        keywords: [],
    },
    '🦺': {
        keywords: [],
    },
    '👔': {
        keywords: ['shirt', 'formal', 'clothing'],
    },
    '👕': {
        keywords: ['tshirt', 'clothing'],
    },
    '👖': {
        keywords: ['pants', 'clothing', 'trousers'],
    },
    '🧣': {
        keywords: [],
    },
    '🧤': {
        keywords: [],
    },
    '🧥': {
        keywords: [],
    },
    '🧦': {
        keywords: [],
    },
    '👗': {
        keywords: ['clothing'],
    },
    '👘': {
        keywords: ['clothing'],
    },
    '🥻': {
        keywords: [],
    },
    '🩱': {
        keywords: [],
    },
    '🩲': {
        keywords: [],
    },
    '🩳': {
        keywords: [],
    },
    '👙': {
        keywords: ['beach', 'clothing', 'swim'],
    },
    '👚': {
        keywords: ['clothing', 'woman'],
    },
    '👛': {
        keywords: ['clothing', 'coin'],
    },
    '👜': {
        keywords: ['bag', 'clothing'],
    },
    '👝': {
        keywords: ['bag', 'clothing'],
    },
    '🛍️': {
        keywords: ['bags'],
    },
    '🎒': {
        keywords: ['activity', 'bag', 'satchel', 'school'],
    },
    '🩴': {
        keywords: [],
    },
    '👞': {
        keywords: ['shoe', 'clothing', 'man'],
    },
    '👟': {
        keywords: ['sneaker', 'sport', 'running', 'athletic', 'clothing', 'shoe'],
    },
    '🥾': {
        keywords: [],
    },
    '🥿': {
        keywords: [],
    },
    '👠': {
        keywords: ['shoe', 'clothing', 'heel', 'woman'],
    },
    '👡': {
        keywords: ['shoe', 'clothing', 'woman'],
    },
    '🩰': {
        keywords: [],
    },
    '👢': {
        keywords: ['clothing', 'shoe', 'woman'],
    },
    '👑': {
        keywords: ['king', 'queen', 'royal', 'clothing'],
    },
    '👒': {
        keywords: ['clothing', 'hat', 'woman'],
    },
    '🎩': {
        keywords: ['hat', 'classy', 'activity', 'clothing', 'entertainment', 'top'],
    },
    '🎓': {
        keywords: ['education', 'college', 'university', 'graduation', 'activity', 'cap', 'celebration', 'clothing', 'hat'],
    },
    '🧢': {
        keywords: [],
    },
    '🪖': {
        keywords: [],
    },
    '⛑️': {
        keywords: [],
    },
    '📿': {
        keywords: ['beads', 'clothing', 'necklace', 'prayer', 'religion'],
    },
    '💄': {
        keywords: ['makeup', 'cosmetics'],
    },
    '💍': {
        keywords: ['wedding', 'marriage', 'engaged', 'diamond', 'romance'],
    },
    '💎': {
        keywords: ['diamond', 'jewel', 'romance'],
    },
    '🔇': {
        keywords: ['sound', 'volume', 'quiet', 'silent', 'speaker'],
    },
    '🔈': {
        keywords: ['volume'],
    },
    '🔉': {
        keywords: ['volume', 'low', 'speaker', 'wave'],
    },
    '🔊': {
        keywords: ['volume', '3', 'entertainment', 'high', 'loud', 'speaker', 'three'],
    },
    '📢': {
        keywords: ['announcement', 'communication', 'loud', 'public address'],
    },
    '📣': {
        keywords: ['cheering', 'communication', 'megaphone'],
    },
    '📯': {
        keywords: ['communication', 'entertainment', 'horn', 'post', 'postal'],
    },
    '🔔': {
        keywords: ['sound', 'notification'],
    },
    '🔕': {
        keywords: ['volume', 'off', 'bell', 'forbidden', 'mute', 'no', 'not', 'prohibited', 'quiet', 'silent'],
    },
    '🎼': {
        keywords: ['activity', 'entertainment', 'music', 'score'],
    },
    '🎵': {
        keywords: ['activity', 'entertainment', 'music', 'note'],
    },
    '🎶': {
        keywords: ['music', 'activity', 'entertainment', 'note'],
    },
    '🎙️': {
        keywords: ['podcast'],
    },
    '🎚️': {
        keywords: [],
    },
    '🎛️': {
        keywords: [],
    },
    '🎤': {
        keywords: ['sing', 'activity', 'entertainment', 'karaoke', 'mic'],
    },
    '🎧': {
        keywords: ['music', 'earphones', 'activity', 'earbud', 'entertainment', 'headphone'],
    },
    '📻': {
        keywords: ['podcast', 'entertainment', 'video'],
    },
    '🎷': {
        keywords: ['activity', 'entertainment', 'instrument', 'music', 'sax'],
    },
    '🪗': {
        keywords: [],
    },
    '🎸': {
        keywords: ['rock', 'activity', 'entertainment', 'instrument', 'music'],
    },
    '🎹': {
        keywords: ['piano', 'activity', 'entertainment', 'instrument', 'keyboard', 'music'],
    },
    '🎺': {
        keywords: ['activity', 'entertainment', 'instrument', 'music'],
    },
    '🎻': {
        keywords: ['activity', 'entertainment', 'instrument', 'music'],
    },
    '🪕': {
        keywords: [],
    },
    '🥁': {
        keywords: ['drumsticks', 'music'],
    },
    '🪘': {
        keywords: [],
    },
    '📱': {
        keywords: ['smartphone', 'mobile', 'cell', 'communication', 'phone', 'telephone'],
    },
    '📲': {
        keywords: ['call', 'incoming', 'arrow', 'cell', 'communication', 'mobile', 'phone', 'receive', 'telephone'],
    },
    '☎️': {
        keywords: ['telephone'],
    },
    '📞': {
        keywords: ['phone', 'call', 'communication', 'receiver', 'telephone'],
    },
    '📟': {
        keywords: ['communication'],
    },
    '📠': {
        keywords: ['communication'],
    },
    '🔋': {
        keywords: ['power'],
    },
    '🔌': {
        keywords: ['electric', 'electricity', 'plug'],
    },
    '💻': {
        keywords: ['desktop', 'screen', 'pc', 'personal'],
    },
    '🖥️': {
        keywords: [],
    },
    '🖨️': {
        keywords: [],
    },
    '⌨️': {
        keywords: ['computer'],
    },
    '🖱️': {
        keywords: [],
    },
    '🖲️': {
        keywords: [],
    },
    '💽': {
        keywords: ['computer', 'disk', 'entertainment', 'minidisk', 'optical'],
    },
    '💾': {
        keywords: ['save', 'computer', 'disk', 'floppy'],
    },
    '💿': {
        keywords: ['blu-ray', 'computer', 'disk', 'dvd', 'optical'],
    },
    '📀': {
        keywords: ['blu-ray', 'cd', 'computer', 'disk', 'entertainment', 'optical'],
    },
    '🧮': {
        keywords: [],
    },
    '🎥': {
        keywords: ['film', 'video', 'activity', 'camera', 'cinema', 'entertainment', 'movie'],
    },
    '🎞️': {
        keywords: [],
    },
    '📽️': {
        keywords: [],
    },
    '🎬': {
        keywords: ['film', 'activity', 'entertainment', 'movie'],
    },
    '📺': {
        keywords: ['entertainment', 'television', 'video'],
    },
    '📷': {
        keywords: ['photo', 'entertainment', 'video'],
    },
    '📸': {
        keywords: ['photo', 'camera', 'flash', 'video'],
    },
    '📹': {
        keywords: ['camera', 'entertainment', 'video'],
    },
    '📼': {
        keywords: ['entertainment', 'tape', 'video', 'videocassette'],
    },
    '🔍': {
        keywords: ['search', 'zoom', 'glass', 'magnifying', 'tool'],
    },
    '🔎': {
        keywords: ['glass', 'magnifying', 'search', 'tool'],
    },
    '🕯️': {
        keywords: [],
    },
    '💡': {
        keywords: ['idea', 'light', 'comic', 'electric'],
    },
    '🔦': {
        keywords: ['electric', 'light', 'tool', 'torch'],
    },
    '🏮': {
        keywords: ['lantern', 'bar', 'japanese', 'light', 'red'],
    },
    '🪔': {
        keywords: [],
    },
    '📔': {
        keywords: ['book', 'cover', 'decorated', 'notebook'],
    },
    '📕': {
        keywords: ['book', 'closed'],
    },
    '📖': {
        keywords: ['open_book', 'open'],
    },
    '📗': {
        keywords: ['book', 'green'],
    },
    '📘': {
        keywords: ['blue', 'book'],
    },
    '📙': {
        keywords: ['book', 'orange'],
    },
    '📚': {
        keywords: ['library', 'book'],
    },
    '📓': {
        keywords: [],
    },
    '📒': {
        keywords: ['notebook'],
    },
    '📃': {
        keywords: ['curl', 'document', 'page'],
    },
    '📜': {
        keywords: ['document', 'paper'],
    },
    '📄': {
        keywords: ['document', 'page'],
    },
    '📰': {
        keywords: ['press', 'communication', 'news', 'paper'],
    },
    '🗞️': {
        keywords: ['press'],
    },
    '📑': {
        keywords: ['bookmark', 'mark', 'marker', 'tabs'],
    },
    '🔖': {
        keywords: ['mark'],
    },
    '🏷️': {
        keywords: ['tag'],
    },
    '💰': {
        keywords: ['dollar', 'cream', 'bag', 'money'],
    },
    '🪙': {
        keywords: [],
    },
    '💴': {
        keywords: ['bank', 'banknote', 'bill', 'currency', 'money', 'note'],
    },
    '💵': {
        keywords: ['money', 'bank', 'banknote', 'bill', 'currency', 'note'],
    },
    '💶': {
        keywords: ['bank', 'banknote', 'bill', 'currency', 'money', 'note'],
    },
    '💷': {
        keywords: ['bank', 'banknote', 'bill', 'currency', 'money', 'note'],
    },
    '💸': {
        keywords: ['dollar', 'bank', 'banknote', 'bill', 'fly', 'money', 'note', 'wings'],
    },
    '💳': {
        keywords: ['subscription', 'bank', 'card', 'credit', 'money'],
    },
    '🧾': {
        keywords: [],
    },
    '💹': {
        keywords: ['bank', 'currency', 'graph', 'growth', 'market', 'money', 'rise', 'trend', 'upward', 'yen'],
    },
    '✉️': {
        keywords: ['letter', 'email', 'e-mail'],
    },
    '📧': {
        keywords: ['e-mail', 'communication', 'letter', 'mail'],
    },
    '📨': {
        keywords: ['communication', 'e-mail', 'email', 'envelope', 'incoming', 'letter', 'mail', 'receive'],
    },
    '📩': {
        keywords: ['arrow', 'communication', 'down', 'e-mail', 'email', 'envelope', 'letter', 'mail', 'outgoing', 'sent'],
    },
    '📤': {
        keywords: ['box', 'communication', 'letter', 'mail', 'outbox', 'sent', 'tray'],
    },
    '📥': {
        keywords: ['box', 'communication', 'inbox', 'letter', 'mail', 'receive', 'tray'],
    },
    '📦': {
        keywords: ['shipping', 'box', 'communication', 'parcel'],
    },
    '📫': {
        keywords: ['closed', 'communication', 'flag', 'mail', 'postbox'],
    },
    '📪': {
        keywords: ['closed', 'communication', 'flag', 'lowered', 'mail', 'mailbox', 'postbox'],
    },
    '📬': {
        keywords: ['communication', 'flag', 'mail', 'mailbox', 'open', 'postbox'],
    },
    '📭': {
        keywords: ['communication', 'flag', 'lowered', 'mail', 'mailbox', 'open', 'postbox'],
    },
    '📮': {
        keywords: ['communication', 'mail', 'mailbox'],
    },
    '🗳️': {
        keywords: [],
    },
    '✏️': {
        keywords: [],
    },
    '✒️': {
        keywords: ['nib', 'pen'],
    },
    '🖋️': {
        keywords: [],
    },
    '🖊️': {
        keywords: [],
    },
    '🖌️': {
        keywords: [],
    },
    '🖍️': {
        keywords: [],
    },
    '📝': {
        keywords: ['document', 'note', 'pencil', 'communication'],
    },
    '💼': {
        keywords: ['business'],
    },
    '📁': {
        keywords: ['directory', 'file', 'folder'],
    },
    '📂': {
        keywords: ['file', 'folder', 'open'],
    },
    '🗂️': {
        keywords: [],
    },
    '📅': {
        keywords: ['calendar', 'schedule'],
    },
    '📆': {
        keywords: ['schedule'],
    },
    '🗒️': {
        keywords: [],
    },
    '🗓️': {
        keywords: [],
    },
    '📇': {
        keywords: ['card', 'index', 'rolodex'],
    },
    '📈': {
        keywords: ['graph', 'metrics', 'chart', 'growth', 'trend', 'upward'],
    },
    '📉': {
        keywords: ['graph', 'metrics', 'chart', 'down', 'trend'],
    },
    '📊': {
        keywords: ['stats', 'metrics', 'bar', 'chart', 'graph'],
    },
    '📋': {
        keywords: [],
    },
    '📌': {
        keywords: ['location', 'pin'],
    },
    '📍': {
        keywords: ['location', 'pin', 'pushpin'],
    },
    '📎': {
        keywords: [],
    },
    '🖇️': {
        keywords: [],
    },
    '📏': {
        keywords: ['ruler', 'straight edge'],
    },
    '📐': {
        keywords: ['ruler', 'set', 'triangle'],
    },
    '✂️': {
        keywords: ['cut', 'tool'],
    },
    '🗃️': {
        keywords: [],
    },
    '🗄️': {
        keywords: [],
    },
    '🗑️': {
        keywords: ['trash'],
    },
    '🔒': {
        keywords: ['security', 'private', 'closed'],
    },
    '🔓': {
        keywords: ['security', 'lock', 'open'],
    },
    '🔏': {
        keywords: ['ink', 'lock', 'nib', 'pen', 'privacy'],
    },
    '🔐': {
        keywords: ['security', 'closed', 'key', 'lock', 'secure'],
    },
    '🔑': {
        keywords: ['lock', 'password'],
    },
    '🗝️': {
        keywords: [],
    },
    '🔨': {
        keywords: ['tool'],
    },
    '🪓': {
        keywords: [],
    },
    '⛏️': {
        keywords: [],
    },
    '⚒️': {
        keywords: ['hammer', 'pick', 'tool'],
    },
    '🛠️': {
        keywords: [],
    },
    '🗡️': {
        keywords: [],
    },
    '⚔️': {
        keywords: ['crossed', 'swords', 'weapon'],
    },
    '🔫': {
        keywords: ['shoot', 'weapon', 'handgun', 'pistol', 'revolver', 'tool'],
    },
    '🪃': {
        keywords: [],
    },
    '🏹': {
        keywords: ['archery', 'archer', 'arrow', 'bow', 'sagittarius', 'tool', 'weapon', 'zodiac'],
    },
    '🛡️': {
        keywords: [],
    },
    '🪚': {
        keywords: [],
    },
    '🔧': {
        keywords: ['tool'],
    },
    '🪛': {
        keywords: [],
    },
    '🔩': {
        keywords: ['bolt', 'nut', 'tool'],
    },
    '⚙️': {
        keywords: ['tool'],
    },
    '🗜️': {
        keywords: [],
    },
    '⚖️': {
        keywords: ['balance', 'justice', 'libra', 'scales', 'tool', 'weight', 'zodiac'],
    },
    '🦯': {
        keywords: [],
    },
    '🔗': {
        keywords: [],
    },
    '⛓️': {
        keywords: [],
    },
    '🪝': {
        keywords: [],
    },
    '🧰': {
        keywords: [],
    },
    '🧲': {
        keywords: [],
    },
    '🪜': {
        keywords: [],
    },
    '⚗️': {
        keywords: ['chemistry', 'tool'],
    },
    '🧪': {
        keywords: [],
    },
    '🧫': {
        keywords: [],
    },
    '🧬': {
        keywords: [],
    },
    '🔬': {
        keywords: ['science', 'laboratory', 'investigate', 'tool'],
    },
    '🔭': {
        keywords: ['tool'],
    },
    '📡': {
        keywords: ['signal', 'antenna', 'communication', 'dish'],
    },
    '💉': {
        keywords: ['health', 'hospital', 'needle', 'doctor', 'medicine', 'shot', 'sick', 'tool'],
    },
    '🩸': {
        keywords: [],
    },
    '💊': {
        keywords: ['health', 'medicine', 'doctor', 'sick'],
    },
    '🩹': {
        keywords: [],
    },
    '🩺': {
        keywords: [],
    },
    '🚪': {
        keywords: [],
    },
    '🛗': {
        keywords: [],
    },
    '🪞': {
        keywords: [],
    },
    '🪟': {
        keywords: [],
    },
    '🛏️': {
        keywords: [],
    },
    '🛋️': {
        keywords: [],
    },
    '🪑': {
        keywords: [],
    },
    '🚽': {
        keywords: ['wc'],
    },
    '🪠': {
        keywords: [],
    },
    '🚿': {
        keywords: ['bath', 'water'],
    },
    '🛁': {
        keywords: ['bath'],
    },
    '🪤': {
        keywords: [],
    },
    '🪒': {
        keywords: [],
    },
    '🧴': {
        keywords: [],
    },
    '🧷': {
        keywords: [],
    },
    '🧹': {
        keywords: [],
    },
    '🧺': {
        keywords: [],
    },
    '🧻': {
        keywords: ['toilet'],
    },
    '🪣': {
        keywords: [],
    },
    '🧼': {
        keywords: [],
    },
    '🪥': {
        keywords: [],
    },
    '🧽': {
        keywords: [],
    },
    '🧯': {
        keywords: [],
    },
    '🛒': {
        keywords: ['cart', 'shopping', 'trolley'],
    },
    '🚬': {
        keywords: ['cigarette', 'activity'],
    },
    '⚰️': {
        keywords: ['funeral'],
    },
    '🪦': {
        keywords: [],
    },
    '⚱️': {
        keywords: [],
    },
    '🗿': {
        keywords: ['stone', 'face', 'statue'],
    },
    '🪧': {
        keywords: [],
    },
    '🏧': {
        keywords: ['automated', 'bank', 'teller'],
    },
    '🚮': {
        keywords: ['litter', 'litterbox'],
    },
    '🚰': {
        keywords: ['drink', 'potable', 'water'],
    },
    '♿': {
        keywords: ['accessibility', 'access'],
    },
    '🚹': {
        keywords: ['lavatory', 'man', 'restroom', 'wc'],
    },
    '🚺': {
        keywords: ['lavatory', 'restroom', 'wc', 'woman'],
    },
    '🚻': {
        keywords: ['toilet', 'lavatory', 'wc'],
    },
    '🚼': {
        keywords: ['baby', 'changing'],
    },
    '🚾': {
        keywords: ['toilet', 'restroom', 'closet', 'lavatory', 'water'],
    },
    '🛂': {
        keywords: ['control', 'passport'],
    },
    '🛃': {
        keywords: [],
    },
    '🛄': {
        keywords: ['airport', 'baggage', 'claim'],
    },
    '🛅': {
        keywords: ['baggage', 'left luggage', 'locker', 'luggage'],
    },
    '⚠️': {
        keywords: ['wip'],
    },
    '🚸': {
        keywords: ['child', 'crossing', 'pedestrian', 'traffic'],
    },
    '⛔': {
        keywords: ['limit', 'entry', 'forbidden', 'no', 'not', 'prohibited', 'traffic'],
    },
    '🚫': {
        keywords: ['block', 'forbidden', 'entry', 'no', 'not', 'prohibited'],
    },
    '🚳': {
        keywords: ['bicycle', 'bike', 'forbidden', 'no', 'not', 'prohibited', 'vehicle'],
    },
    '🚭': {
        keywords: ['forbidden', 'no', 'not', 'prohibited', 'smoking'],
    },
    '🚯': {
        keywords: ['forbidden', 'litter', 'no', 'not', 'prohibited'],
    },
    '🚱': {
        keywords: ['drink', 'forbidden', 'no', 'not', 'potable', 'prohibited', 'water'],
    },
    '🚷': {
        keywords: ['forbidden', 'no', 'not', 'pedestrian', 'prohibited'],
    },
    '📵': {
        keywords: ['cell', 'communication', 'forbidden', 'mobile', 'no', 'not', 'phone', 'prohibited', 'telephone'],
    },
    '🔞': {
        keywords: ['18', 'age restriction', 'eighteen', 'forbidden', 'no', 'not', 'prohibited'],
    },
    '☢️': {
        keywords: [],
    },
    '☣️': {
        keywords: [],
    },
    '⬆️': {
        keywords: [],
    },
    '↗️': {
        keywords: ['arrow', 'direction', 'intercardinal', 'northeast'],
    },
    '➡️': {
        keywords: [],
    },
    '↘️': {
        keywords: ['arrow', 'direction', 'intercardinal', 'southeast'],
    },
    '⬇️': {
        keywords: [],
    },
    '↙️': {
        keywords: ['arrow', 'direction', 'intercardinal', 'southwest'],
    },
    '⬅️': {
        keywords: [],
    },
    '↖️': {
        keywords: ['arrow', 'direction', 'intercardinal', 'northwest'],
    },
    '↕️': {
        keywords: ['arrow'],
    },
    '↔️': {
        keywords: ['arrow'],
    },
    '↩️': {
        keywords: ['return'],
    },
    '↪️': {
        keywords: [],
    },
    '⤴️': {
        keywords: ['arrow', 'up'],
    },
    '⤵️': {
        keywords: ['arrow', 'down'],
    },
    '🔃': {
        keywords: ['arrow', 'clockwise', 'reload'],
    },
    '🔄': {
        keywords: ['sync', 'anticlockwise', 'arrow', 'counterclockwise', 'withershins'],
    },
    '🔙': {
        keywords: ['arrow'],
    },
    '🔚': {
        keywords: ['arrow'],
    },
    '🔛': {
        keywords: ['arrow', 'mark'],
    },
    '🔜': {
        keywords: ['arrow'],
    },
    '🔝': {
        keywords: ['arrow', 'up'],
    },
    '🛐': {
        keywords: ['religion', 'worship'],
    },
    '⚛️': {
        keywords: [],
    },
    '🕉️': {
        keywords: [],
    },
    '✡️': {
        keywords: ['david', 'jew', 'jewish', 'religion', 'star'],
    },
    '☸️': {
        keywords: ['buddhist', 'dharma', 'religion', 'wheel'],
    },
    '☯️': {
        keywords: [],
    },
    '✝️': {
        keywords: [],
    },
    '☦️': {
        keywords: ['christian', 'cross', 'religion'],
    },
    '☪️': {
        keywords: [],
    },
    '☮️': {
        keywords: [],
    },
    '🕎': {
        keywords: ['candelabrum', 'candlestick', 'religion'],
    },
    '🔯': {
        keywords: ['fortune', 'star'],
    },
    '♈': {
        keywords: ['ram', 'zodiac'],
    },
    '♉': {
        keywords: ['bull', 'ox', 'zodiac'],
    },
    '♊': {
        keywords: ['twins', 'zodiac'],
    },
    '♋': {
        keywords: ['crab', 'zodiac'],
    },
    '♌': {
        keywords: ['lion', 'zodiac'],
    },
    '♍': {
        keywords: ['maiden', 'virgin', 'zodiac'],
    },
    '♎': {
        keywords: ['balance', 'justice', 'scales', 'zodiac'],
    },
    '♏': {
        keywords: ['scorpio', 'scorpion', 'zodiac'],
    },
    '♐': {
        keywords: ['archer', 'zodiac'],
    },
    '♑': {
        keywords: ['goat', 'zodiac'],
    },
    '♒': {
        keywords: ['bearer', 'water', 'zodiac'],
    },
    '♓': {
        keywords: ['fish', 'zodiac'],
    },
    '⛎': {
        keywords: ['bearer', 'serpent', 'snake', 'zodiac'],
    },
    '🔀': {
        keywords: ['shuffle', 'arrow', 'crossed'],
    },
    '🔁': {
        keywords: ['loop', 'arrow', 'clockwise'],
    },
    '🔂': {
        keywords: ['arrow', 'clockwise', 'once'],
    },
    '▶️': {
        keywords: [],
    },
    '⏩': {
        keywords: ['arrow', 'double', 'fast', 'forward'],
    },
    '⏭️': {
        keywords: [],
    },
    '⏯️': {
        keywords: [],
    },
    '◀️': {
        keywords: [],
    },
    '⏪': {
        keywords: ['arrow', 'double'],
    },
    '⏮️': {
        keywords: [],
    },
    '🔼': {
        keywords: ['arrow', 'button', 'red'],
    },
    '⏫': {
        keywords: ['arrow', 'double'],
    },
    '🔽': {
        keywords: ['arrow', 'button', 'down', 'red'],
    },
    '⏬': {
        keywords: ['arrow', 'double', 'down'],
    },
    '⏸️': {
        keywords: [],
    },
    '⏹️': {
        keywords: [],
    },
    '⏺️': {
        keywords: [],
    },
    '⏏️': {
        keywords: [],
    },
    '🎦': {
        keywords: ['film', 'movie', 'activity', 'camera', 'entertainment'],
    },
    '🔅': {
        keywords: ['brightness', 'dim', 'low'],
    },
    '🔆': {
        keywords: ['bright', 'brightness'],
    },
    '📶': {
        keywords: ['wifi', 'antenna', 'bar', 'cell', 'communication', 'mobile', 'phone', 'signal', 'telephone'],
    },
    '📳': {
        keywords: ['cell', 'communication', 'mobile', 'mode', 'phone', 'telephone', 'vibration'],
    },
    '📴': {
        keywords: ['mute', 'off', 'cell', 'communication', 'mobile', 'phone', 'telephone'],
    },
    '♀️': {
        keywords: [],
    },
    '♂️': {
        keywords: [],
    },
    '⚧️': {
        keywords: [],
    },
    '✖️': {
        keywords: ['cancel', 'multiplication', 'multiply', 'x'],
    },
    '➕': {
        keywords: ['math', 'plus'],
    },
    '➖': {
        keywords: ['math', 'minus'],
    },
    '➗': {
        keywords: ['division', 'math'],
    },
    '♾️': {
        keywords: [],
    },
    '‼️': {
        keywords: [],
    },
    '⁉️': {
        keywords: ['exclamation', 'mark', 'punctuation', 'question'],
    },
    '❓': {
        keywords: ['confused', 'mark', 'punctuation'],
    },
    '❔': {
        keywords: ['mark', 'outlined', 'punctuation', 'question'],
    },
    '❕': {
        keywords: ['exclamation', 'mark', 'outlined', 'punctuation'],
    },
    '❗': {
        keywords: ['bang', 'heavy_exclamation_mark', 'mark', 'punctuation'],
    },
    '〰️': {
        keywords: ['dash', 'punctuation', 'wavy'],
    },
    '💱': {
        keywords: ['bank', 'currency', 'exchange', 'money'],
    },
    '💲': {
        keywords: ['currency', 'dollar', 'money'],
    },
    '⚕️': {
        keywords: [],
    },
    '♻️': {
        keywords: ['environment', 'green'],
    },
    '⚜️': {
        keywords: [],
    },
    '🔱': {
        keywords: ['anchor', 'emblem', 'ship', 'tool'],
    },
    '📛': {
        keywords: ['badge', 'name'],
    },
    '🔰': {
        keywords: ['chevron', 'green', 'japanese', 'leaf', 'tool', 'yellow'],
    },
    '⭕': {
        keywords: ['circle'],
    },
    '✅': {
        keywords: ['check', 'mark'],
    },
    '☑️': {
        keywords: ['ballot', 'box', 'check'],
    },
    '✔️': {
        keywords: ['check', 'mark'],
    },
    '❌': {
        keywords: ['cancel', 'mark', 'multiplication', 'multiply'],
    },
    '❎': {
        keywords: ['mark', 'square'],
    },
    '➰': {
        keywords: ['curl', 'loop'],
    },
    '➿': {
        keywords: ['curl', 'double'],
    },
    '〽️': {
        keywords: [],
    },
    '✳️': {
        keywords: ['asterisk'],
    },
    '✴️': {
        keywords: ['star'],
    },
    '❇️': {
        keywords: [],
    },
    '©️': {
        keywords: [],
    },
    '®️': {
        keywords: [],
    },
    '™️': {
        keywords: ['trademark', 'mark'],
    },
    '#️⃣': {
        keywords: ['number', 'keycap', 'pound'],
    },
    '*️⃣': {
        keywords: ['keycap', 'star'],
    },
    '0️⃣': {
        keywords: ['0', 'keycap'],
    },
    '1️⃣': {
        keywords: ['1', 'keycap'],
    },
    '2️⃣': {
        keywords: ['2', 'keycap'],
    },
    '3️⃣': {
        keywords: ['3', 'keycap'],
    },
    '4️⃣': {
        keywords: ['4', 'keycap'],
    },
    '5️⃣': {
        keywords: ['5', 'keycap'],
    },
    '6️⃣': {
        keywords: ['6', 'keycap'],
    },
    '7️⃣': {
        keywords: ['7', 'keycap'],
    },
    '8️⃣': {
        keywords: ['8', 'keycap'],
    },
    '9️⃣': {
        keywords: ['9', 'keycap'],
    },
    '🔟': {
        keywords: ['10', 'keycap', 'ten'],
    },
    '🔠': {
        keywords: ['letters', 'input', 'latin', 'uppercase'],
    },
    '🔡': {
        keywords: ['input', 'latin', 'letters', 'lowercase'],
    },
    '🔢': {
        keywords: ['numbers', 'input'],
    },
    '🔣': {
        keywords: ['input'],
    },
    '🔤': {
        keywords: ['alphabet', 'input', 'latin', 'letters'],
    },
    '🅰️': {
        keywords: [],
    },
    '🆎': {
        keywords: ['blood'],
    },
    '🅱️': {
        keywords: [],
    },
    '🆑': {
        keywords: [],
    },
    '🆒': {
        keywords: [],
    },
    '🆓': {
        keywords: [],
    },
    ℹ️: {
        keywords: ['i', 'information'],
    },
    '🆔': {
        keywords: ['identity'],
    },
    'Ⓜ️': {
        keywords: [],
    },
    '🆕': {
        keywords: ['fresh'],
    },
    '🆖': {
        keywords: [],
    },
    '🅾️': {
        keywords: [],
    },
    '🆗': {
        keywords: ['yes'],
    },
    '🅿️': {
        keywords: [],
    },
    '🆘': {
        keywords: ['help', 'emergency'],
    },
    '🆙': {
        keywords: ['mark'],
    },
    '🆚': {
        keywords: ['versus'],
    },
    '🈁': {
        keywords: ['japanese'],
    },
    '🈂️': {
        keywords: [],
    },
    '🈷️': {
        keywords: [],
    },
    '🈶': {
        keywords: ['japanese'],
    },
    '🈯': {
        keywords: ['japanese'],
    },
    '🉐': {
        keywords: ['japanese'],
    },
    '🈹': {
        keywords: ['japanese'],
    },
    '🈚': {
        keywords: ['japanese'],
    },
    '🈲': {
        keywords: ['japanese'],
    },
    '🉑': {
        keywords: ['chinese'],
    },
    '🈸': {
        keywords: ['chinese'],
    },
    '🈴': {
        keywords: ['chinese'],
    },
    '🈳': {
        keywords: ['chinese'],
    },
    '㊗️': {
        keywords: ['chinese', 'congratulation', 'ideograph'],
    },
    '㊙️': {
        keywords: ['chinese', 'ideograph'],
    },
    '🈺': {
        keywords: ['chinese'],
    },
    '🈵': {
        keywords: ['chinese'],
    },
    '🔴': {
        keywords: ['circle', 'geometric', 'red'],
    },
    '🟠': {
        keywords: [],
    },
    '🟡': {
        keywords: [],
    },
    '🟢': {
        keywords: [],
    },
    '🔵': {
        keywords: ['blue', 'circle', 'geometric'],
    },
    '🟣': {
        keywords: [],
    },
    '🟤': {
        keywords: [],
    },
    '⚫': {
        keywords: ['circle', 'geometric'],
    },
    '⚪': {
        keywords: ['circle', 'geometric'],
    },
    '🟥': {
        keywords: [],
    },
    '🟧': {
        keywords: [],
    },
    '🟨': {
        keywords: [],
    },
    '🟩': {
        keywords: [],
    },
    '🟦': {
        keywords: [],
    },
    '🟪': {
        keywords: [],
    },
    '🟫': {
        keywords: [],
    },
    '⬛': {
        keywords: ['geometric', 'square'],
    },
    '⬜': {
        keywords: ['geometric', 'square'],
    },
    '◼️': {
        keywords: [],
    },
    '◻️': {
        keywords: [],
    },
    '◾': {
        keywords: ['geometric', 'square'],
    },
    '◽': {
        keywords: ['geometric', 'square'],
    },
    '▪️': {
        keywords: [],
    },
    '▫️': {
        keywords: [],
    },
    '🔶': {
        keywords: ['diamond', 'geometric', 'orange'],
    },
    '🔷': {
        keywords: ['blue', 'diamond', 'geometric'],
    },
    '🔸': {
        keywords: ['diamond', 'geometric', 'orange'],
    },
    '🔹': {
        keywords: ['blue', 'diamond', 'geometric'],
    },
    '🔺': {
        keywords: ['geometric', 'red'],
    },
    '🔻': {
        keywords: ['down', 'geometric', 'red'],
    },
    '💠': {
        keywords: ['comic', 'diamond', 'geometric', 'inside'],
    },
    '🔘': {
        keywords: ['button', 'geometric', 'radio'],
    },
    '🔳': {
        keywords: ['button', 'geometric', 'outlined', 'square'],
    },
    '🔲': {
        keywords: ['button', 'geometric', 'square'],
    },
    '🏁': {
        keywords: ['milestone', 'finish', 'checkered', 'chequered', 'flag', 'racing'],
    },
    '🚩': {
        keywords: ['flag', 'post'],
    },
    '🎌': {
        keywords: ['activity', 'celebration', 'cross', 'crossed', 'flag', 'japanese'],
    },
    '🏴': {
        keywords: ['flag', 'waving'],
    },
    '🏳️': {
        keywords: [],
    },
    '🏳️‍🌈': {
        keywords: ['pride'],
    },
    '🏳️‍⚧️': {
        keywords: [],
    },
    '🏴‍☠️': {
        keywords: [],
    },
    '🇦🇨': {
        keywords: ['ascension', 'flag', 'island'],
    },
    '🇦🇩': {
        keywords: ['flag'],
    },
    '🇦🇪': {
        keywords: ['emirates', 'flag', 'uae', 'united'],
    },
    '🇦🇫': {
        keywords: ['flag'],
    },
    '🇦🇬': {
        keywords: ['antigua', 'barbuda', 'flag'],
    },
    '🇦🇮': {
        keywords: ['flag'],
    },
    '🇦🇱': {
        keywords: ['flag'],
    },
    '🇦🇲': {
        keywords: ['flag'],
    },
    '🇦🇴': {
        keywords: ['flag'],
    },
    '🇦🇶': {
        keywords: ['flag'],
    },
    '🇦🇷': {
        keywords: ['flag'],
    },
    '🇦🇸': {
        keywords: ['american', 'flag', 'samoa'],
    },
    '🇦🇹': {
        keywords: ['flag'],
    },
    '🇦🇺': {
        keywords: ['flag'],
    },
    '🇦🇼': {
        keywords: ['flag'],
    },
    '🇦🇽': {
        keywords: ['åland', 'flag'],
    },
    '🇦🇿': {
        keywords: ['flag'],
    },
    '🇧🇦': {
        keywords: ['bosnia', 'flag', 'herzegovina'],
    },
    '🇧🇧': {
        keywords: ['flag'],
    },
    '🇧🇩': {
        keywords: ['flag'],
    },
    '🇧🇪': {
        keywords: ['flag'],
    },
    '🇧🇫': {
        keywords: ['burkina faso', 'flag'],
    },
    '🇧🇬': {
        keywords: ['flag'],
    },
    '🇧🇭': {
        keywords: ['flag'],
    },
    '🇧🇮': {
        keywords: ['flag'],
    },
    '🇧🇯': {
        keywords: ['flag'],
    },
    '🇧🇱': {
        keywords: ['barthelemy', 'barthélemy', 'flag', 'saint'],
    },
    '🇧🇲': {
        keywords: ['flag'],
    },
    '🇧🇳': {
        keywords: ['darussalam', 'flag'],
    },
    '🇧🇴': {
        keywords: ['flag'],
    },
    '🇧🇶': {
        keywords: ['bonaire', 'caribbean', 'eustatius', 'flag', 'netherlands', 'saba', 'sint'],
    },
    '🇧🇷': {
        keywords: ['flag'],
    },
    '🇧🇸': {
        keywords: ['flag'],
    },
    '🇧🇹': {
        keywords: ['flag'],
    },
    '🇧🇻': {
        keywords: ['bouvet', 'flag', 'island'],
    },
    '🇧🇼': {
        keywords: ['flag'],
    },
    '🇧🇾': {
        keywords: ['flag'],
    },
    '🇧🇿': {
        keywords: ['flag'],
    },
    '🇨🇦': {
        keywords: ['flag'],
    },
    '🇨🇨': {
        keywords: ['keeling', 'cocos', 'flag', 'island'],
    },
    '🇨🇩': {
        keywords: ['congo', 'congo-kinshasa', 'democratic republic of congo', 'drc', 'flag', 'kinshasa', 'republic'],
    },
    '🇨🇫': {
        keywords: ['central african republic', 'flag', 'republic'],
    },
    '🇨🇬': {
        keywords: ['brazzaville', 'congo', 'congo republic', 'congo-brazzaville', 'flag', 'republic', 'republic of the congo'],
    },
    '🇨🇭': {
        keywords: ['flag'],
    },
    '🇨🇮': {
        keywords: ['ivory', 'cote ivoire', 'côte ivoire', 'flag', 'ivory coast'],
    },
    '🇨🇰': {
        keywords: ['cook', 'flag', 'island'],
    },
    '🇨🇱': {
        keywords: ['flag'],
    },
    '🇨🇲': {
        keywords: ['flag'],
    },
    '🇨🇳': {
        keywords: ['china', 'flag'],
    },
    '🇨🇴': {
        keywords: ['flag'],
    },
    '🇨🇵': {
        keywords: ['clipperton', 'flag', 'island'],
    },
    '🇨🇷': {
        keywords: ['costa rica', 'flag'],
    },
    '🇨🇺': {
        keywords: ['flag'],
    },
    '🇨🇻': {
        keywords: ['cabo', 'cape', 'flag', 'verde'],
    },
    '🇨🇼': {
        keywords: ['antilles', 'curaçao', 'flag'],
    },
    '🇨🇽': {
        keywords: ['christmas', 'flag', 'island'],
    },
    '🇨🇾': {
        keywords: ['flag'],
    },
    '🇨🇿': {
        keywords: ['czech republic', 'flag'],
    },
    '🇩🇪': {
        keywords: ['flag', 'germany'],
    },
    '🇩🇬': {
        keywords: ['diego garcia', 'flag'],
    },
    '🇩🇯': {
        keywords: ['flag'],
    },
    '🇩🇰': {
        keywords: ['flag'],
    },
    '🇩🇲': {
        keywords: ['flag'],
    },
    '🇩🇴': {
        keywords: ['dominican republic', 'flag'],
    },
    '🇩🇿': {
        keywords: ['flag'],
    },
    '🇪🇦': {
        keywords: ['ceuta', 'flag', 'melilla'],
    },
    '🇪🇨': {
        keywords: ['flag'],
    },
    '🇪🇪': {
        keywords: ['flag'],
    },
    '🇪🇬': {
        keywords: ['flag'],
    },
    '🇪🇭': {
        keywords: ['flag', 'sahara', 'west', 'western sahara'],
    },
    '🇪🇷': {
        keywords: ['flag'],
    },
    '🇪🇸': {
        keywords: ['spain', 'flag'],
    },
    '🇪🇹': {
        keywords: ['flag'],
    },
    '🇪🇺': {
        keywords: ['european_union', 'european union', 'flag'],
    },
    '🇫🇮': {
        keywords: ['flag'],
    },
    '🇫🇯': {
        keywords: ['flag'],
    },
    '🇫🇰': {
        keywords: ['falkland', 'falklands', 'flag', 'island', 'islas', 'malvinas'],
    },
    '🇫🇲': {
        keywords: ['flag'],
    },
    '🇫🇴': {
        keywords: ['faroe', 'flag', 'island'],
    },
    '🇫🇷': {
        keywords: ['france', 'french', 'flag'],
    },
    '🇬🇦': {
        keywords: ['flag'],
    },
    '🇬🇧': {
        keywords: ['flag', 'british', 'uk', 'britain', 'cornwall', 'england', 'great britain', 'ireland', 'northern ireland', 'scotland', 'union jack', 'united', 'united kingdom', 'wales'],
    },
    '🇬🇩': {
        keywords: ['flag'],
    },
    '🇬🇪': {
        keywords: ['flag'],
    },
    '🇬🇫': {
        keywords: ['flag', 'french', 'guiana'],
    },
    '🇬🇬': {
        keywords: ['flag'],
    },
    '🇬🇭': {
        keywords: ['flag'],
    },
    '🇬🇮': {
        keywords: ['flag'],
    },
    '🇬🇱': {
        keywords: ['flag'],
    },
    '🇬🇲': {
        keywords: ['flag'],
    },
    '🇬🇳': {
        keywords: ['flag'],
    },
    '🇬🇵': {
        keywords: ['flag'],
    },
    '🇬🇶': {
        keywords: ['equatorial guinea', 'flag', 'guinea'],
    },
    '🇬🇷': {
        keywords: ['flag'],
    },
    '🇬🇸': {
        keywords: ['flag', 'georgia', 'island', 'south', 'south georgia', 'south sandwich'],
    },
    '🇬🇹': {
        keywords: ['flag'],
    },
    '🇬🇺': {
        keywords: ['flag'],
    },
    '🇬🇼': {
        keywords: ['bissau', 'flag', 'guinea'],
    },
    '🇬🇾': {
        keywords: ['flag'],
    },
    '🇭🇰': {
        keywords: ['china', 'flag', 'hong kong'],
    },
    '🇭🇲': {
        keywords: ['flag', 'heard', 'island', 'mcdonald'],
    },
    '🇭🇳': {
        keywords: ['flag'],
    },
    '🇭🇷': {
        keywords: ['flag'],
    },
    '🇭🇹': {
        keywords: ['flag'],
    },
    '🇭🇺': {
        keywords: ['flag'],
    },
    '🇮🇨': {
        keywords: ['canary', 'flag', 'island'],
    },
    '🇮🇩': {
        keywords: ['flag'],
    },
    '🇮🇪': {
        keywords: ['flag'],
    },
    '🇮🇱': {
        keywords: ['flag'],
    },
    '🇮🇲': {
        keywords: ['flag', 'isle of man'],
    },
    '🇮🇳': {
        keywords: ['flag'],
    },
    '🇮🇴': {
        keywords: ['british', 'chagos', 'flag', 'indian ocean', 'island'],
    },
    '🇮🇶': {
        keywords: ['flag'],
    },
    '🇮🇷': {
        keywords: ['flag'],
    },
    '🇮🇸': {
        keywords: ['flag'],
    },
    '🇮🇹': {
        keywords: ['italy', 'flag'],
    },
    '🇯🇪': {
        keywords: ['flag'],
    },
    '🇯🇲': {
        keywords: ['flag'],
    },
    '🇯🇴': {
        keywords: ['flag'],
    },
    '🇯🇵': {
        keywords: ['japan', 'flag'],
    },
    '🇰🇪': {
        keywords: ['flag'],
    },
    '🇰🇬': {
        keywords: ['flag'],
    },
    '🇰🇭': {
        keywords: ['flag'],
    },
    '🇰🇮': {
        keywords: ['flag'],
    },
    '🇰🇲': {
        keywords: ['flag'],
    },
    '🇰🇳': {
        keywords: ['flag', 'kitts', 'nevis', 'saint'],
    },
    '🇰🇵': {
        keywords: ['flag', 'korea', 'north', 'north korea'],
    },
    '🇰🇷': {
        keywords: ['korea', 'flag', 'south', 'south korea'],
    },
    '🇰🇼': {
        keywords: ['flag'],
    },
    '🇰🇾': {
        keywords: ['cayman', 'flag', 'island'],
    },
    '🇰🇿': {
        keywords: ['flag'],
    },
    '🇱🇦': {
        keywords: ['flag'],
    },
    '🇱🇧': {
        keywords: ['flag'],
    },
    '🇱🇨': {
        keywords: ['flag', 'lucia', 'saint'],
    },
    '🇱🇮': {
        keywords: ['flag'],
    },
    '🇱🇰': {
        keywords: ['flag', 'sri lanka'],
    },
    '🇱🇷': {
        keywords: ['flag'],
    },
    '🇱🇸': {
        keywords: ['flag'],
    },
    '🇱🇹': {
        keywords: ['flag'],
    },
    '🇱🇺': {
        keywords: ['flag'],
    },
    '🇱🇻': {
        keywords: ['flag'],
    },
    '🇱🇾': {
        keywords: ['flag'],
    },
    '🇲🇦': {
        keywords: ['flag'],
    },
    '🇲🇨': {
        keywords: ['flag'],
    },
    '🇲🇩': {
        keywords: ['flag'],
    },
    '🇲🇪': {
        keywords: ['flag'],
    },
    '🇲🇫': {
        keywords: ['flag', 'french', 'martin', 'saint'],
    },
    '🇲🇬': {
        keywords: ['flag'],
    },
    '🇲🇭': {
        keywords: ['flag', 'island', 'marshall'],
    },
    '🇲🇰': {
        keywords: ['flag'],
    },
    '🇲🇱': {
        keywords: ['flag'],
    },
    '🇲🇲': {
        keywords: ['burma', 'flag'],
    },
    '🇲🇳': {
        keywords: ['flag'],
    },
    '🇲🇴': {
        keywords: ['china', 'flag', 'macao'],
    },
    '🇲🇵': {
        keywords: ['flag', 'island', 'mariana', 'north', 'northern mariana'],
    },
    '🇲🇶': {
        keywords: ['flag'],
    },
    '🇲🇷': {
        keywords: ['flag'],
    },
    '🇲🇸': {
        keywords: ['flag'],
    },
    '🇲🇹': {
        keywords: ['flag'],
    },
    '🇲🇺': {
        keywords: ['flag'],
    },
    '🇲🇻': {
        keywords: ['flag'],
    },
    '🇲🇼': {
        keywords: ['flag'],
    },
    '🇲🇽': {
        keywords: ['flag'],
    },
    '🇲🇾': {
        keywords: ['flag'],
    },
    '🇲🇿': {
        keywords: ['flag'],
    },
    '🇳🇦': {
        keywords: ['flag'],
    },
    '🇳🇨': {
        keywords: ['flag', 'new', 'new caledonia'],
    },
    '🇳🇪': {
        keywords: ['flag'],
    },
    '🇳🇫': {
        keywords: ['flag', 'island', 'norfolk'],
    },
    '🇳🇬': {
        keywords: ['flag'],
    },
    '🇳🇮': {
        keywords: ['flag'],
    },
    '🇳🇱': {
        keywords: ['flag'],
    },
    '🇳🇴': {
        keywords: ['flag'],
    },
    '🇳🇵': {
        keywords: ['flag'],
    },
    '🇳🇷': {
        keywords: ['flag'],
    },
    '🇳🇺': {
        keywords: ['flag'],
    },
    '🇳🇿': {
        keywords: ['flag', 'new', 'new zealand'],
    },
    '🇴🇲': {
        keywords: ['flag'],
    },
    '🇵🇦': {
        keywords: ['flag'],
    },
    '🇵🇪': {
        keywords: ['flag'],
    },
    '🇵🇫': {
        keywords: ['flag', 'french', 'polynesia'],
    },
    '🇵🇬': {
        keywords: ['flag', 'guinea', 'new', 'papua new guinea'],
    },
    '🇵🇭': {
        keywords: ['flag'],
    },
    '🇵🇰': {
        keywords: ['flag'],
    },
    '🇵🇱': {
        keywords: ['flag'],
    },
    '🇵🇲': {
        keywords: ['flag', 'miquelon', 'pierre', 'saint'],
    },
    '🇵🇳': {
        keywords: ['flag', 'island', 'pitcairn'],
    },
    '🇵🇷': {
        keywords: ['flag', 'puerto rico'],
    },
    '🇵🇸': {
        keywords: ['flag', 'palestine'],
    },
    '🇵🇹': {
        keywords: ['flag'],
    },
    '🇵🇼': {
        keywords: ['flag'],
    },
    '🇵🇾': {
        keywords: ['flag'],
    },
    '🇶🇦': {
        keywords: ['flag'],
    },
    '🇷🇪': {
        keywords: ['flag', 'réunion'],
    },
    '🇷🇴': {
        keywords: ['flag'],
    },
    '🇷🇸': {
        keywords: ['flag'],
    },
    '🇷🇺': {
        keywords: ['russia', 'flag'],
    },
    '🇷🇼': {
        keywords: ['flag'],
    },
    '🇸🇦': {
        keywords: ['flag', 'saudi arabia'],
    },
    '🇸🇧': {
        keywords: ['flag', 'island', 'solomon'],
    },
    '🇸🇨': {
        keywords: ['flag'],
    },
    '🇸🇩': {
        keywords: ['flag'],
    },
    '🇸🇪': {
        keywords: ['flag'],
    },
    '🇸🇬': {
        keywords: ['flag'],
    },
    '🇸🇭': {
        keywords: ['flag', 'helena', 'saint'],
    },
    '🇸🇮': {
        keywords: ['flag'],
    },
    '🇸🇯': {
        keywords: ['flag', 'jan mayen', 'svalbard'],
    },
    '🇸🇰': {
        keywords: ['flag'],
    },
    '🇸🇱': {
        keywords: ['flag', 'sierra leone'],
    },
    '🇸🇲': {
        keywords: ['flag', 'san marino'],
    },
    '🇸🇳': {
        keywords: ['flag'],
    },
    '🇸🇴': {
        keywords: ['flag'],
    },
    '🇸🇷': {
        keywords: ['flag'],
    },
    '🇸🇸': {
        keywords: ['flag', 'south', 'south sudan', 'sudan'],
    },
    '🇸🇹': {
        keywords: ['flag', 'principe', 'príncipe', 'sao tome', 'são tomé'],
    },
    '🇸🇻': {
        keywords: ['el salvador', 'flag'],
    },
    '🇸🇽': {
        keywords: ['flag', 'maarten', 'sint'],
    },
    '🇸🇾': {
        keywords: ['flag'],
    },
    '🇸🇿': {
        keywords: ['flag'],
    },
    '🇹🇦': {
        keywords: ['flag', 'tristan da cunha'],
    },
    '🇹🇨': {
        keywords: ['caicos', 'flag', 'island', 'turks'],
    },
    '🇹🇩': {
        keywords: ['flag'],
    },
    '🇹🇫': {
        keywords: ['antarctic', 'flag', 'french'],
    },
    '🇹🇬': {
        keywords: ['flag'],
    },
    '🇹🇭': {
        keywords: ['flag'],
    },
    '🇹🇯': {
        keywords: ['flag'],
    },
    '🇹🇰': {
        keywords: ['flag'],
    },
    '🇹🇱': {
        keywords: ['east', 'east timor', 'flag', 'timor-leste'],
    },
    '🇹🇲': {
        keywords: ['flag'],
    },
    '🇹🇳': {
        keywords: ['flag'],
    },
    '🇹🇴': {
        keywords: ['flag'],
    },
    '🇹🇷': {
        keywords: ['turkey', 'flag'],
    },
    '🇹🇹': {
        keywords: ['flag', 'tobago', 'trinidad'],
    },
    '🇹🇻': {
        keywords: ['flag'],
    },
    '🇹🇼': {
        keywords: ['china', 'flag'],
    },
    '🇹🇿': {
        keywords: ['flag'],
    },
    '🇺🇦': {
        keywords: ['flag'],
    },
    '🇺🇬': {
        keywords: ['flag'],
    },
    '🇺🇲': {
        keywords: ['america', 'flag', 'island', 'minor outlying', 'united', 'united states', 'us', 'usa'],
    },
    '🇺🇳': {
        keywords: ['flag'],
    },
    '🇺🇸': {
        keywords: ['flag', 'united', 'america', 'stars and stripes', 'united states'],
    },
    '🇺🇾': {
        keywords: ['flag'],
    },
    '🇺🇿': {
        keywords: ['flag'],
    },
    '🇻🇦': {
        keywords: ['flag', 'vatican'],
    },
    '🇻🇨': {
        keywords: ['flag', 'grenadines', 'saint', 'vincent'],
    },
    '🇻🇪': {
        keywords: ['flag'],
    },
    '🇻🇬': {
        keywords: ['british', 'flag', 'island', 'virgin'],
    },
    '🇻🇮': {
        keywords: ['america', 'american', 'flag', 'island', 'united', 'united states', 'us', 'usa', 'virgin'],
    },
    '🇻🇳': {
        keywords: ['flag', 'viet nam'],
    },
    '🇻🇺': {
        keywords: ['flag'],
    },
    '🇼🇫': {
        keywords: ['flag', 'futuna', 'wallis'],
    },
    '🇼🇸': {
        keywords: ['flag'],
    },
    '🇽🇰': {
        keywords: ['flag'],
    },
    '🇾🇪': {
        keywords: ['flag'],
    },
    '🇾🇹': {
        keywords: ['flag'],
    },
    '🇿🇦': {
        keywords: ['flag', 'south', 'south africa'],
    },
    '🇿🇲': {
        keywords: ['flag'],
    },
    '🇿🇼': {
        keywords: ['flag'],
    },
    '🏴󠁧󠁢󠁥󠁮󠁧󠁿': {
        keywords: ['flag'],
    },
    '🏴󠁧󠁢󠁳󠁣󠁴󠁿': {
        keywords: ['flag'],
    },
    '🏴󠁧󠁢󠁷󠁬󠁳󠁿': {
        keywords: ['flag'],
    },
};

export default enEmojis;
